import { Component, OnInit, OnDestroy, AfterViewInit, DoCheck, inject, effect, ChangeDetectorRef, Renderer2, ViewChild, ElementRef, EventEmitter, HostListener } from '@angular/core';
import { Location } from '@angular/common'; import { MenuItem, MessageService } from 'primeng/api'; import { WidgetsService } from 'src/app/services/widgets.service';
import { takeUntil, map, debounceTime } from 'rxjs/operators'; import { FormBuilder, FormGroup } from '@angular/forms'; import { BehaviorSubject } from 'rxjs';
import { Subject, Observable } from 'rxjs'; import { ActivatedRoute } from '@angular/router'; import { AssetsResponse, WidgetDetailsResponse } from './models';
import { RuleGroupNode, createEmptyGroup, buildRuleTreeFromLegacy } from 'src/app/models/widget-rule.model';
import { WidgetHelperService } from 'src/app/services/widget-helper.service'; import { Router } from '@angular/router'; import { environment } from 'src/environments/environment';
import { FeedService, Feed, User, ListFeedsPayload } from 'src/app/services/feed.service'; import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { PosthogService } from 'src/app/services/posthog.service';
import { ModalstateService } from 'src/app/services/modalstate.service'; import { ViewportService } from 'src/app/services/viewport.service';
// import { WidgetTemplateComponent } from '../widget-template/widget-template.component'; 
import { StoreService } from 'src/app/services/store.service';

import { ProductService } from 'src/app/services/product.service';
interface ResolutionOption {
  label: string;
  value: { width: number; height: number };
  selected?: boolean; // Opcional, pois nem todos os itens terão `selected`
}
interface FeedOption {
  label: string;
  value: string;
  source_id: string;
  feed_type: string;
  hashtag_name?: string;
  type?: string;
  published_count?: number;
}
@Component({
  selector: 'app-edit-widget',
  templateUrl: './edit-widget.component.html',
  styleUrls: ['./edit-widget.component.scss']
})
export class EditWidgetComponent implements OnInit, OnDestroy, AfterViewInit, DoCheck {
  viewPortSerice = inject(ViewportService);
  @ViewChild('containerDiv', { static: false }) containerDivRef!: ElementRef<HTMLDivElement>; isDragDrop: boolean = false; resolutions: { label: string; value: { width: number; height: number } }[] = [];
  selectedResolution: any; widgetTemplateEventEmitter = new EventEmitter<void>(); isAdmin: boolean = true;
  displaySidebar: boolean = false; ctaOptions: MenuItem[] = []; popupPositions: any[] = []; issueForm?: FormGroup; widget_id!: number; widget_uid?: string; selectedTemplate: string = 'Criando Widget';
  stepStatusCollapsed: boolean = false;
  activeOption: number | null = 2; hasError1: boolean = false; hasErrorFeeds: boolean = false; selectedPopupPosition: 'center' | 'top' | 'bottom' | 'left' | 'right' | 'topleft' | 'topright' | 'bottomleft' | 'bottomright' = 'bottomleft';
  template_uid?: string; store_id?: number; height?: number; aspectRatio: any; //template_id?:number;  
  hasErrorTitle: boolean = false; hasError2: boolean = false; hasError3: boolean = false; displayAguarde: boolean = false; height_inline: number = 0;
  widgetPublished: boolean = false; saveBtnDisabled: boolean = true; isLoadingSave: boolean = false; limitShowItens: boolean = false; showDescription?: boolean = false; showProducts?: boolean = false; bg_color: string = '#ffffff'; font_color: string = '#000000';
  showClearSlicksTags: boolean = false; loading: boolean = true; widgetTitle?: string; highlight?: string; parsedFeeds?: any;
  widgetTypes: any[] = []; slickTypes: any[] = []; selectedWidgetType: string = ''; selectedSlickType: string = ''; filteredResults: any[] = [];
  filteredResultsSlicks: any[] = []; sourceProducts: any[] = []; targetProducts: any[] = []; skeletonSource: any[] = [];
  private assetsPage = 1;
  private readonly assetsLimit = 15;
  private assetsPageLimit = 15;
  private assetsNextPage: number | null = null;
  private assetsHasNextPage = false;
  private assetsIsLoadingMore = false;
  private currentAssetsFilter: string | undefined = undefined;
  private readonly assetsLoadingSentinel: any = { __loading: true, id: -1, uid: '__loading__' };

  get sourceProductsCount(): number {
    return (this.sourceProducts || []).filter((p: any) => !p?.__loading).length;
  }

  getProductDescription(product: any): string {
    return (product?.description ?? product?.caption ?? '') as string;
  }
  valuesSlicksTags: string[] | undefined; manualValue: number | null = null; createWidgetBtn: boolean = false;
  showSmartphones: boolean = true; showDesktops: boolean = true; valSelect1Video: any = { value: 1 }; refreshTrigger: boolean = false;
  integrationPlatform: 'shopify' | 'nuvemshop' | null = null;
  showWidgetTitle: boolean = false;
  widgetTitleTag: string = 'h2';
  titleTagOptions = [
    { label: 'H1', value: 'h1' },
    { label: 'H2', value: 'h2' },
    { label: 'H3', value: 'h3' },
    { label: 'H4', value: 'h4' },
    { label: 'H5', value: 'h5' },
    { label: 'H6', value: 'h6' },
  ];
  titleAlignment: 'left' | 'center' | 'right' = 'left';
  titleAlignmentOptions = [
    { label: 'Esquerda', value: 'left', icon: 'pi pi-align-left' },
    { label: 'Centro', value: 'center', icon: 'pi pi-align-center' },
    { label: 'Direita', value: 'right', icon: 'pi pi-align-right' },
  ];
  titleSpacing: number = 24;

  linkPaddingX: boolean = true;
  linkPaddingY: boolean = false;
  paddingTop: number = 0;
  paddingRight: number = 0;
  paddingBottom: number = 0;
  paddingLeft: number = 0;
  paddingUnit: 'px' | 'rem' | '%' = 'px';

  // Valores de espaçamento específicos pro preview/telas mobile — editados
  // quando o seletor Desktop/Mobile do topo (valSelect1Video) está em Mobile.
  // Fazem fallback pro valor desktop quando ausentes (widgets salvos antes
  // dessa feature continuam exibindo o mesmo espaçamento nos dois devices).
  paddingTopMobile: number = 0;
  paddingRightMobile: number = 0;
  paddingBottomMobile: number = 0;
  paddingLeftMobile: number = 0;

  linkMarginX: boolean = true;
  linkMarginY: boolean = false;
  marginTop: number = 0;
  marginRight: number = 0;
  marginBottom: number = 0;
  marginLeft: number = 0;
  marginUnit: 'px' | 'rem' | '%' = 'px';

  marginTopMobile: number = 0;
  marginRightMobile: number = 0;
  marginBottomMobile: number = 0;
  marginLeftMobile: number = 0;

  spacingUnitOptions = [
    { label: 'PX', value: 'px' },
    { label: 'REM', value: 'rem' },
    { label: '%', value: '%' },
  ];
  // Faixas/incrementos diferentes por unidade (px:0-120 passo 4; rem:0-8 passo
  // 0.25; %:0-100 passo 1) — trocar de unidade NÃO converte o valor numérico
  // já digitado, só reinterpreta o que ele significa (mesmo comportamento do
  // Webflow), então o usuário deve reajustar o número ao trocar de unidade.
  private readonly spacingUnitConfig: Record<'px' | 'rem' | '%', { min: number; max: number; step: number; maxFractionDigits: number }> = {
    px: { min: 0, max: 120, step: 4, maxFractionDigits: 0 },
    rem: { min: 0, max: 8, step: 0.25, maxFractionDigits: 2 },
    '%': { min: 0, max: 100, step: 1, maxFractionDigits: 0 },
  };
  get paddingUnitConfig() { return this.spacingUnitConfig[this.paddingUnit]; }
  get marginUnitConfig() { return this.spacingUnitConfig[this.marginUnit]; }
  private defaultStoreDomain?: string;
  landscapeOptions2 = [{ icon: 'pi pi-mobile', name: 'Desktop', value: 1 }, { icon: 'pi pi-mobile rotate-90', name: 'Mobile', value: 2 },];
  shapeOptions = [{ label: 'Portrait', value: 'portrait' }, { label: 'Landscape', value: 'landscape' }, { label: 'Circle', value: 'circle' }];
  script_share: string = '<script type="text/javascript" src="https://cdn.slicksell.com.br/atlas.js" defer></script>';
  widget_share: string = '';
  templateType?: string = 'stories';
  selectedShape: string = '';
  get integrationContext(): EditWidgetComponent {
    return this;
  }
  get integrationLabel(): string {
    return this.integrationPlatform === 'nuvemshop' ? 'Nuvemshop' : 'Shopify';
  }
  get integrationIcon(): string {
    return this.integrationPlatform === 'nuvemshop'
      ? 'assets/vagasbyintera_nuvemshop-tiendanube-og.png'
      : 'assets/shopify_glyph.png';
  }
  private previousTargetOrder: any[] = [];
  private isFirstCheck = true;
  isWidgetDetailsLoaded = false;
  ///////////////////
  private targetProductsSubject = new BehaviorSubject<any[]>([]);
  targetProducts$ = this.targetProductsSubject.asObservable();
  ///////////////////

  @ViewChild('assetsPickList', { read: ElementRef })
  set assetsPickListRef(ref: ElementRef<HTMLElement> | undefined) {
    this._assetsPickListRef = ref;
    // PickList pode alternar (desktop/mobile). Reanexa sempre que aparecer.
    setTimeout(() => this.attachAssetsPickListScrollListener(), 0);
  }
  private _assetsPickListRef?: ElementRef<HTMLElement>;
  private pickListSourceScrollEl?: HTMLElement;
  private pickListSourceScrollHandler?: (ev: Event) => void;

  private hasTargetProductsChanged(): boolean {
    const currentOrder = JSON.stringify(this.targetProducts);
    const previousOrder = JSON.stringify(this.previousTargetOrder);
    const orderChanged = currentOrder !== previousOrder;
    this.previousTargetOrder = [...this.targetProducts]; // Atualiza a referência para a próxima verificação
    return orderChanged;
  }

  async handleTargetReorder() {
    let stCS;
    clearTimeout(stCS);
    stCS = setTimeout(() => {
      this.editWidget(0);
    }, 150);

  }
  templates: any[] = [
    { name: 'Carousel', key: 'carousel', icon: 'pi pi-video' },
    { name: 'Discover', key: 'discover', icon: 'bi bi-fire' },
    { name: 'Popup', key: 'popup', icon: 'pi pi-mobile' },
    { name: 'Inline', key: 'inline', icon: 'pi pi-mobile' },
    { name: 'Stories', key: 'stories', icon: 'pi pi-mobile' }
  ];
  /////////////////////////////
  discoverLayoutOptions = [
    { value: 'mosaic', icon: 'bi bi-grid-1x2', label: 'Mosaico' },
    { value: 'grid', icon: 'bi bi-grid-3x3-gap', label: 'Grid' },
  ];
  discoverLayout: 'mosaic' | 'grid' = 'mosaic';
   // novo switch
  // Discover options
  discoverDesignOptions = [
    { value: 'grid', icon: 'bi bi-grid-3x3-gap', label: 'Grid' },
    { value: 'book', icon: 'bi bi-book', label: 'Book' },
  ];

  discoverIconOptions = [
    { value: 'cart', icon: 'pi pi-shopping-cart' },
    { value: 'bag', icon: 'pi pi-shopping-bag' },
  ];

  // valores selecionados
  discoverDesign: 'grid' | 'book' = 'grid';
  discoverIcon: 'cart' | 'bag' = 'cart';
  discoverShowFilterBar = true;
  discoverShowPostItemBadge:boolean = true;
  /////////////////////////////
  private destroy$ = new Subject<void>();
  // Debounce pro auto-save das seções Título e Espaçamento (painéis de HTML e de
  // integração Nuvemshop/Shopify chamam isso a cada clique nos steppers de padding/
  // margin — sem debounce, disparava uma chamada de save por clique).
  private autoSaveTrigger$ = new Subject<void>();
  scheduleAutoSave(): void {
    this.autoSaveTrigger$.next();
  }
  conditionOptions = [
    { label: 'Igual', value: 'igual' },
    { label: 'Contém', value: 'contem' }
  ];
  filteredConditionOptions = [...this.conditionOptions];
  selectedCondition: string = this.conditionOptions[0].value;
  // valuesEqualTags/valuesContainTags: mantidos só pelo formato antigo
  // (contain_rule/equal_rule, lista plana em OR) que ainda é enviado junto
  // por compatibilidade — a UI (rule-builder) e a avaliação real no backend
  // usam exclusivamente this.ruleTree agora.
  valuesEqualTags: string[] = [];
  valuesContainTags: string[] = [];
  ruleTree: RuleGroupNode = createEmptyGroup();
  showClearEqualTags: boolean = false; isNewWidget: boolean = false;
  showClearContainTags: boolean = false; isCreateMode: boolean = false;
  constructor(
    private productService: ProductService, private errorHandler: ErrorHandlerService,
    private posthogService: PosthogService,
    private feedService: FeedService,
    private widgetService: WidgetsService, private router: Router, private storeService: StoreService, public fb: FormBuilder, private route: ActivatedRoute, private messageService: MessageService, private modalStateService: ModalstateService,
    private cdr: ChangeDetectorRef, private location: Location, private renderer: Renderer2, private widgetHelperService: WidgetHelperService
  ) {
    this.issueForm = this.fb.group({
      type: [0], // Valor fixo para type
      title: [''], // O valor do campo de título
      feed_type: [''], // O valor do tipo de feed (manual ou tags)
      slick_filter: [''], // O valor do tipo de slick
      max_limit: [null], // Valor de limite
      smart: [0], // Valor fixo para smart
      tags: [''], // Tags em formato string
      template: ['Pip'], // Valor fixo para template
      url_display: ['www'], // Valor fixo para URL display
      assets: [[]], // IDs dos assets do picklist
      style: this.fb.group({}),
      widget_rule: this.fb.group({
        device_display: this.fb.group({
          mobile: [false], // Valor inicial para dispositivos móveis
          desktop: [false] // Valor inicial para desktops
        }),
        url_display: this.fb.group({
          contain_rule: [''], // String para URLs separadas por vírgula
          equal_rule: [''] // String para URLs separadas por vírgula
        })
      })
    });

    effect(() => {
      let templateType = this.viewPortSerice.getTemplateType()();
      if (templateType == 'iframe') {
        this.height = this.viewPortSerice.getDivHeightSignal()();
      } else {
        this.height = this.viewPortSerice.getDivHeightSignal()();
      }
      this.cdr.detectChanges();
    });

    this.breadcrumbItems = [
      { label: 'Configurações', command: () => this.navigateToConfigurations() },
      { label: 'Integrações', command: () => this.navigateToIntegrations() },
      { label: 'Domínios Permitidos', command: () => this.navigateToDomains() }
    ];
  }
  currentWidgetUid?: string;
  activeTabIndex: number = 0;
  setActiveTab(index: number) {
    this.activeTabIndex = index;
  }
  ss_page?: string;
  ss_platform?: string;
  ss_homepage_url?: string;
  ss_shopify_theme_id?: string;
  ss_url_page?: string;
  storeEditToken?: string;
  storeEditTokenExpiresAt?: string;

  private previewContainerObserver?: ResizeObserver;
  // .layout-content-wrapper/.layout-content são do app-layout (ancestral),
  // não deste componente — CSS com escopo local (mesmo ::ng-deep) não alcança
  // ancestrais, só descendentes. Por isso o padding-bottom é zerado via DOM
  // direto aqui, e desfeito no ngOnDestroy, pra valer só enquanto esta tela
  // estiver aberta.
  private layoutPaddingBottomEls: HTMLElement[] = [];
  private removeLayoutPaddingBottom(): void {
    document.querySelectorAll<HTMLElement>('.layout-content-wrapper, .layout-content').forEach(el => {
      this.renderer.setStyle(el, 'padding-bottom', '0');
      this.layoutPaddingBottomEls.push(el);
    });
  }
  ngAfterViewInit(): void {
    setTimeout(() => this.updateLayoutMaxHeight(), 0);
    this.removeLayoutPaddingBottom();

    // O teto de altura do layout depende de onde o layout começa na página
    // (não só de scroll/resize da janela) — troca de template, carregamento de
    // imagem, itens adicionados etc. também podem mudar essa posição.
    const previewEl = this.containerDivRef?.nativeElement;
    if (previewEl && typeof ResizeObserver !== 'undefined') {
      this.previewContainerObserver = new ResizeObserver(() => this.updateLayoutMaxHeight());
      this.previewContainerObserver.observe(previewEl);
    }
  }

  ngOnInit(): void { // embed sourceProducts
    this.autoSaveTrigger$.pipe(debounceTime(3000), takeUntil(this.destroy$)).subscribe(() => {
      this.editWidget(0);
    });

    this.targetProducts$.subscribe((newTargetProducts) => {
      if (JSON.stringify(newTargetProducts) !== JSON.stringify(this.previousTargetOrder)) {
        this.handleTargetReorder();
      }
      this.previousTargetOrder = [...newTargetProducts]; // Atualiza a referência
    });

    let storeId = Number(localStorage.getItem('ss_SelectedStoreId'));

    if (!Number.isFinite(storeId) || storeId <= 0) {
      const rawStore = localStorage.getItem('store');
      if (rawStore) {
        try {
          const obj = JSON.parse(rawStore);
          storeId = Number(obj?.SelectedStoreId);
        } catch { }
      }
    }

    this.store_id = (Number.isFinite(storeId) && storeId > 0) ? storeId : 0;

    let loja: string = '';
    const domainStore = localStorage.getItem('domain_store'); // Obtém o valor do localStorage
    this.defaultStoreDomain = domainStore || undefined;

    if (domainStore) {
      // Extrai o subdomínio (parte antes do primeiro ponto)
      const match = domainStore.match(/^([^\.]+)\./);
      loja = match ? match[1] : ''; // Se o subdomínio for encontrado, use-o, caso contrário, mantenha vazio
    }
    this.widget_share = `<iframe src="${environment.frontendUrl}/${loja}" frameborder="0" width="100px" height="100px"></iframe>`;

    this.isCreateMode = this.location.path().includes('/create_widget');
    this.selectedCondition = this.conditionOptions[0].value;
    this.valSelect1Video = this.landscapeOptions2[0];
    this.isCompactView = window.innerWidth < 992;
    this.displaySidebar = this.isCompactView;
    this.modalStateService.modalOpened$.subscribe((isModalOpen) => {
    });
    this.popupPositions = this.widgetHelperService.getPopupPositions();
    this.resolutions = this.widgetHelperService.getResolutions(); // selectedResolution

    this.refreshCtaOptions();
    this.route.queryParams.subscribe(params => {
      if (params['embed'] === 'true') {
        // Se embed é verdadeiro, seleciona a aba "Embedding"
        this.activeOption = 2;

        setTimeout(() => {
          this.setActiveTab(1);
        }, 500);
        setTimeout(() => {
          this.setActiveTab(0);
        }, 500);
        this.cdr.detectChanges();
      } else {
        // Caso contrário, seleciona a aba padrão
        this.activeOption = 0;
      }
    });
    this.route.url.subscribe(urlSegments => {
      const fullPath = urlSegments.map(segment => segment.path).join('/');
      const uidFromUrl = fullPath.split('/').pop()?.split('?')[0]; // Pega o último segmento antes do `?`

      this.currentWidgetUid = uidFromUrl || '';
    });

    this.updateWidgetTypeOptions();
    this.slickTypes = this.widgetHelperService.getSlickTypes();
    this.filteredResultsSlicks = this.slickTypes;
    this.selectedSlickType = 'all';
    this.skeletonSource = Array(6).fill({});
    this.height = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    this.route.url.subscribe(segments => {
      // Verifica se estamos acessando 'create-widget'
      if (segments.length > 0 && segments[0].path === 'create_widget') {
        // É para criar um novo widget
        this.listAssets().pipe(takeUntil(this.destroy$)).subscribe({
          next: () => {
            this.createWidgetBtn = true;
            this.loading = false;
            this.selectedTemplate = 'carousel';
            this.isNewWidget = true;
          },
          error: (err) => {
            this.loading = false;
            console.error('Erro ao carregar os assets:', err);
          }
        });
      } else {
        this.displayAguarde = true;
        this.route.paramMap.subscribe(params => {
          const uid = params.get('uid');
          if (uid) {
            this.widgetService.detailWidget(uid).pipe(takeUntil(this.destroy$)).subscribe({
              next: (res: WidgetDetailsResponse) => { // parte 2


                this.selectedPageType = this.pageTypes.find(type => type.value === res.page_type)?.value || null;

                if (res.ecom) {
                  const platform = (res.ecom.ss_cart_platform || 'shopify').toLowerCase();
                  const rawCartPage = res.ecom.ss_cart_page ?? '';
                  const normalizedPage = this.normalizeStoreUrl(rawCartPage)?.replace(/\/+$/, '');
                  this.ss_platform = platform;
                  this.ss_homepage_url = rawCartPage;

                  if (platform === 'nuvemshop') {
                    this.ss_page = rawCartPage;
                    this.ss_shopify_theme_id = undefined;
                    this.ss_url_page = normalizedPage ? `${normalizedPage}/admin/v2/themes` : undefined;
                  } else {
                    this.ss_page = rawCartPage.replace(/\.myshopify\.com$/i, '');
                    this.ss_shopify_theme_id = res.ecom.ss_shopify_theme_id;
                    this.ss_url_page = this.ss_shopify_theme_id
                      ? `https://admin.shopify.com/store/${this.ss_page}/themes/${this.ss_shopify_theme_id}/editor`
                      : undefined;
                  }
                }



                this.selectedShape = 'circle';
                this.widget_id = res.id;
                this.widget_uid = res.uid;

                // Bug real corrigido: `this.store_id` só tinha fallback pra
                // `localStorage['ss_SelectedStoreId']` (setado em ngOnInit,
                // linha ~331-343) — se essa chave estivesse ausente/inválida
                // na sessão (link direto, sessão nova, etc.), caía num
                // hardcoded `163` de dev que nunca era corrigido depois. Esse
                // valor errado escorria pra `widget-template` → `carousel`/
                // `discover`/etc. → `VideoModalService.open()` →
                // `video-modal` → toda chamada que o player faz (produtos,
                // eventos, posts por handle — 404/500 reais encontrados).
                // O widget SEMPRE pertence a uma loja real — `detailWidget()`
                // já retorna `store_id`, fonte de verdade, sem depender do
                // localStorage estar correto.
                if (Number.isFinite(res.store_id) && res.store_id > 0) {
                  this.store_id = res.store_id;
                  localStorage.setItem('ss_SelectedStoreId', String(res.store_id));
                }
                this.widgetPublished = !!res.published;
                this.widgetTitle = res.title;
                this.showWidgetTitle = !!res.show_title;
                this.widgetTitleTag = res.title_tag || 'h2';
                this.selectedWidgetType = res.feed_type;
                this.updateWidgetTypeOptions();

                if (this.selectedWidgetType === 'manual') {
                  this.initializeObserver();
                } else {
                  if (this.observer) {
                    this.observer.disconnect();
                  }
                }

                this.filteredTemplates = this.templates.map(template => ({
                  ...template,
                  disabled: this.isTemplateDisabled(template.key) // Adiciona a propriedade 'disabled'
                }));
                this.selectedSlickType = res.slick_filter;
                this.manualValue = res.max_limit;
                if (this.manualValue != undefined && this.manualValue > 0) {
                  this.limitShowItens = true;
                }
                this.valuesSlicksTags = res.tags ? res.tags.split('|') : [];
                this.selectedProdutosIngest = (res.tags ? res.tags.split('|') : [])
                  .filter(tag => tag.startsWith('product_'))
                  .map(tag => Number(tag.replace('product_', '')))
                  .filter(id => Number.isFinite(id));
                this.showSmartphones = res.widget_rule.device_display.mobile_display;
                this.showDesktops = res.widget_rule.device_display.desktop_display;
                this.valuesEqualTags = typeof res.widget_rule.url_display.equal_rule === 'string'
                  ? JSON.parse(res.widget_rule.url_display.equal_rule)
                  : res.widget_rule.url_display.equal_rule || [];

                this.valuesContainTags = typeof res.widget_rule.url_display.contain_rule === 'string'
                  ? JSON.parse(res.widget_rule.url_display.contain_rule)
                  : res.widget_rule.url_display.contain_rule || [];

                // url_rules (árvore nova) tem prioridade; widgets ainda sem
                // ela (nunca reconfigurados no rule-builder novo) têm a
                // árvore construída a partir do formato antigo, só na carga.
                const savedUrlRules = res.widget_rule.url_display.url_rules;
                this.ruleTree = savedUrlRules && typeof savedUrlRules === 'object' && Array.isArray(savedUrlRules.children) && savedUrlRules.children.length > 0
                  ? savedUrlRules
                  : buildRuleTreeFromLegacy(this.valuesEqualTags, this.valuesContainTags);


                if (res.style) {
                  const styleKeys = Object.keys(res.style);
                  if (styleKeys.length > 0) {
                    this.selectedTemplate = styleKeys[0];
                    this.cdr.detectChanges();
                  }
                }

                if (res.style && res.style.discover) {
                  this.discoverDesign = (res.style.discover.design === 'book' || res.style.discover.design === 'grid')
                    ? res.style.discover.design
                    : 'grid';

                  this.discoverIcon = (res.style.discover.icon === 'bag' || res.style.discover.icon === 'cart')
                    ? res.style.discover.icon
                    : 'cart';

                  this.discoverShowFilterBar = (typeof res.style.discover.showFilterBar === 'boolean')
                    ? res.style.discover.showFilterBar
                    : true;

                  this.discoverShowPostItemBadge = (typeof res.style.discover.showBadgeBar === 'boolean')
                    ? res.style.discover.showBadgeBar
                    : true;

                  this.applyNuvemshopWrapperStyleExtras(res.style.discover);
                  this.cdr.detectChanges();
                }

                //////////////////////
                if (res.page_type === 'produtos') {
                  this.showSearchButton = true;
                  if (res.url_display) {
                    this.listarProducts(); // Carregar a listagem de produtos
                    let cleanUrl = this.cleanUrl(res.url_display);
                    this.findAndSetSelectedProduct(cleanUrl);

                  }
                  this.loadDisabledItems(res.page_type);
                } else if (res.page_type === 'colecoes') {
                  this.showSearchButton = true;
                  if (res.url_display) {
                    this.listarCollections();
                    let cleanUrl = this.cleanUrl(res.url_display);
                    this.findAndSetSelectedCollection(cleanUrl);
                  }
                  this.loadDisabledItems(res.page_type);
                } else if (res.page_type === 'artigos') {
                  this.showSearchButton = true;
                  if (res.url_display) {
                    this.listarArticles();
                    let cleanUrl = this.cleanUrl(res.url_display);
                    this.findAndSetSelectedArticle(cleanUrl);
                  }
                  this.loadDisabledItems(res.page_type);
                } else if (res.page_type === 'homepage') {
                  // Nenhuma seleção necessária — url_display é a homepage da loja
                }
                //////////////////////

                if (res.style && res.style.popup) {
                  const position = res.style.popup.position;
                  this.selectedPopupPosition = position && ['center', 'top', 'bottom', 'left', 'right', 'topleft', 'topright', 'bottomleft', 'bottomright'].includes(position)
                    ? this.widgetHelperService.mapPositionValue(position)
                    : 'bottomleft';
                  this.cdr.detectChanges();
                  this.highlight = res.style.popup.highlight || '';
                  this.selectedShape = res.style.popup.shape || 'circle';
                  this.bg_color = res.style.popup.background_color || '#ffffff';
                  this.font_color = res.style.popup.font_color || '#000000';
                  if (res.style.popup.height) {
                    this.height = res.style.popup.height;
                  }

                } else if (res.style && res.style.inline) {
                  this.showDescription = res.style.inline.showDescription;
                  this.showProducts = res.style.inline.showProducts;

                  const savedResolution = res.style.inline.selectedResolution;
                  if (savedResolution) {
                    const resolution = this.resolutions.find(
                      r => r.value.width === savedResolution.width && r.value.height === savedResolution.height
                    );

                    if (resolution) {
                      this.selectedResolution = resolution.value;
                      this.height = resolution.value.height;
                    }
                  }
                  this.applyNuvemshopWrapperStyleExtras(res.style.inline);

                } else if (res.style && res.style.carousel) {
                  this.showProducts = res.style.carousel.showProducts;
                  this.showDescription = res.style.carousel.showDescription;
                  this.bg_color = res.style.carousel.background_color || '#ffffff';
                  this.font_color = res.style.carousel.font_color || '#000000';
                  const position = res.style.carousel.position;
                  this.selectedPopupPosition = position && ['center', 'top', 'bottom', 'left', 'right', 'topleft', 'topright', 'bottomleft', 'bottomright'].includes(position)
                    ? this.widgetHelperService.mapPositionValue(position)
                    : 'bottomleft';
                  this.applyNuvemshopWrapperStyleExtras(res.style.carousel);
                } else if (res.style && res.style.stories) {
                  this.showProducts = res.style.stories.showProducts;
                  this.highlight = res.style.stories.highlight || '';
                  this.bg_color = res.style.stories.background_color || '#ffffff';
                  this.font_color = res.style.stories.font_color || '#000000';
                  const position = res.style.stories.position;
                  this.selectedPopupPosition = position && ['center', 'top', 'bottom', 'left', 'right', 'topleft', 'topright', 'bottomleft', 'bottomright'].includes(position)
                    ? this.widgetHelperService.mapPositionValue(position)
                    : 'bottomleft';
                  this.applyNuvemshopWrapperStyleExtras(res.style.stories);
                } else {
                  this.selectedShape = 'circle';
                }
                this.resolutions = this.widgetHelperService.getResolutions();
                this.selectedResolution = this.resolutions[2].value;
                if (res.style && (res.style.iframe && res.style.iframe.selectedResolution)) {
                  const savedResolution = res.style.iframe.selectedResolution;
                  const resolution = this.resolutions.find(
                    r => r.value.width === savedResolution.width && r.value.height === savedResolution.height
                  );

                  if (resolution) {
                    this.selectedResolution = resolution.value;
                    this.height = resolution.value.height;
                  }


                } else if (res.style && (res.style.inline && res.style.inline.selectedResolution)) {
                  const savedResolution = res.style.inline.selectedResolution;
                  const resolution = this.resolutions.find(
                    r => r.value.width === savedResolution.width && r.value.height === savedResolution.height
                  );

                  if (resolution) {
                    this.selectedResolution = resolution.value;
                    this.height = resolution.value.height;
                  }
                }
                // Definir o aspect ratio com base na resolução selecionada
                const width = this.selectedResolution.width;
                const height = this.selectedResolution.height;
                this.aspectRatio = `${width} / ${height}`;
                if (res.style && res.style.iframe && res.style.iframe.selectedResolution) {
                  let width = 100;
                  if (this.aspectRatio && this.height) {
                    // Separa largura e altura da `aspectRatio`, por exemplo: "16 / 9"
                    const [ratioWidth, ratioHeight] = this.aspectRatio.split('/').map(Number);

                    // Calcula a largura com base na altura e na proporção
                    width = this.height * (ratioWidth / ratioHeight);
                  }
                  let loja: string = '';
                  const domainStore = localStorage.getItem('domain_store'); // Obtém o valor do localStorage

                  if (domainStore) {
                    // Extrai o subdomínio (parte antes do primeiro ponto)
                    const match = domainStore.match(/^([^\.]+)\./);
                    loja = match ? match[1] : ''; // Se o subdomínio for encontrado, use-o, caso contrário, mantenha vazio
                  }
                  this.widget_share = `<iframe src="${environment.frontendUrl}/${loja}" frameborder="0" width="${width}" height="${this.height}"></iframe>`;
                } else {
                  let width = 100;
                  if (this.aspectRatio && this.height) {
                    // Separa largura e altura da `aspectRatio`, por exemplo: "16 / 9"
                    const [ratioWidth, ratioHeight] = this.aspectRatio.split('/').map(Number);

                    // Calcula a largura com base na altura e na proporção
                    width = this.height * (ratioWidth / ratioHeight);
                  }
                  this.widget_share = `<slicksell-widget class="ss-H889djhd6Jjk" template-type="${this.selectedTemplate}" store-id="${this.store_id}" widget-id="${this.widget_id}"></slicksell-widget>`;
                }

                ///////////////////
                if (res.feeds) {
                  try {
                    this.parsedFeeds = JSON.parse(res.feeds);
                  } catch (e) {
                    console.warn('❌ Erro ao fazer parse de feeds:', res.feeds, e);
                    this.parsedFeeds = []; // ou o valor padrão adequado
                  }
                } else {
                  this.parsedFeeds = []; // valor padrão se não existir feeds
                }
                //////////////////


                const desiredLimit = this.assetsLimit + (res.assets?.length ?? 0);
                this.listAssets(this.selectedSlickType, desiredLimit).pipe(takeUntil(this.destroy$)).subscribe({
                  next: () => {
                    // Extraindo os ids dos assets e suas respectivas posições da resposta do detalhe do widget (res)
                    const assetMap = new Map<number, number | null>(
                      res.assets.map(asset => [asset.id, asset.position])
                    );

                    // Filtrando e separando os produtos entre target e source
                    this.targetProducts = this.sourceProducts.filter(product => assetMap.has(product.id));
                    this.sourceProducts = this.sourceProducts.filter(product => !assetMap.has(product.id));

                    // Ordenando os produtos target de acordo com a position
                    this.targetProducts.sort((a, b) => {
                      const positionA = assetMap.get(a.id) ?? 0; // Define 0 como valor padrão se position for null ou undefined
                      const positionB = assetMap.get(b.id) ?? 0; // Define 0 como valor padrão se position for null ou undefined
                      return positionA - positionB;
                    });


                    this.createWidgetBtn = false;
                    this.loading = false;
                    this.displayAguarde = false;
                    // Só libera o skeleton dos steps aqui, depois que targetProducts (hasWidgetItems)
                    // já está populado — senão o p-steps chega a renderizar com o ctaOptions "de
                    // fábrica" (amarelo/vermelho/vermelho) por um instante antes do refresh abaixo.
                    this.refreshCtaOptions();
                    this.isWidgetDetailsLoaded = true;
                    this.cdr.detectChanges();

                    //if (newType === 'feeds') {
                    this.feedService.listFeeds(15, undefined).subscribe({
                      next: (res: any) => {
                        const feeds = res.feeds || [];

                        this.feedsOptions = feeds.map((feed: any) => ({
                          title: feed.title,
                          uid: feed.uid,
                          value: feed.uid,
                          source_id: feed.source_id,
                          feed_type: feed.feed_type,
                          hashtag_name: feed.hastag_name,
                          type: feed.type,
                          published_count: feed.published_count,
                        }));

                        if (this.parsedFeeds) {
                          this.selectedFeeds = this.feedsOptions
                            .filter(f => this.parsedFeeds.includes(f.value))
                            .map(f => f.value); // garante que selecionamos apenas feeds válidos
                        }
                      },
                      error: err => {
                        this.displayAguarde = false;
                        console.error('Erro ao carregar feeds:', err);
                      }
                    });
                    //}

                    this.loadProdutosIngestOptions();

                  },
                  error: (err: any) => {
                    this.loading = false;
                    this.displayAguarde = false;
                  }
                });
              },
              error: (err) => {
                this.loading = false;
              }
            });
          }
        });
      }
    });


    this.loadIntegrationInfo();
  }

  private loadIntegrationInfo(): void {
    this.productService.getStoreIntegration()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (integration) => {
          if (integration?.found && integration.platform) {
            this.applyIntegrationContext(integration.platform, integration.url_store, integration.shopify_theme_id);
          } else {
            this.clearIntegrationContext();
          }
        },
        error: (error) => {
          console.error('Erro ao carregar integração da loja:', error);
          this.clearIntegrationContext();
        }
      });
  }

  // "Produtos" como Tipo de ingest só faz sentido com integração de e-commerce
  // (Shopify/Nuvemshop) — sem isso, loadProdutosIngestOptions() nunca carrega
  // nada e o usuário fica preso num dropdown vazio sem explicação (SSAPP-25).
  // hasIntegration resolve de forma assíncrona (loadIntegrationInfo()), por
  // isso recalculamos toda vez que ele muda, não só no ngOnInit. Widget já
  // existente com type 'produtos' continua mostrando a opção mesmo sem
  // integração (loja pode ter perdido a integração depois de já ter o widget
  // configurado) — não queremos o valor selecionado sumir da lista.
  private updateWidgetTypeOptions(): void {
    const allTypes = this.widgetHelperService.getWidgetTypes();
    this.widgetTypes = (this.hasIntegration || this.selectedWidgetType === 'produtos')
      ? allTypes
      : allTypes.filter(type => type.value !== 'produtos');
    this.filteredResults = this.widgetTypes;
  }

  private applyIntegrationContext(platform: 'shopify' | 'nuvemshop', urlStore?: string | null, shopifyThemeId?: string | null): void {
    this.hasIntegration = true;
    this.integrationPlatform = platform;
    this.updatePageTypeLabels();
    const domain = urlStore ?? this.defaultStoreDomain;
    const normalized = this.normalizeStoreUrl(domain);
    if (normalized) {
      this.url_store = normalized;
    }
    if (platform === 'shopify') {
      this.ss_shopify_theme_id = shopifyThemeId ?? undefined;
      this.ss_page = urlStore ? urlStore.replace(/\.myshopify\.com$/i, '') : this.ss_page;
    } else if (platform === 'nuvemshop') {
      if (urlStore) {
        if (!this.ss_page) this.ss_page = urlStore;
        if (!this.ss_homepage_url) this.ss_homepage_url = urlStore;
      }
      // O token so existe pro editor de posicionamento da Nuvemshop
      // (Tiendanube HTML Editor) — pedir pra loja Shopify sempre voltava 403.
      this.fetchStoreEditToken();
    }
    this.refreshProductDisplayUrls();
    this.refreshCollectionDisplayUrls();
    this.refreshArticleDisplayUrls();

    // Retry: o load do widget (que já tenta carregar produtos eager se o
    // feed_type for 'produtos') roda em paralelo com loadIntegrationInfo() —
    // se essa chamada de integração ainda não tinha resolvido na hora do
    // eager load, loadProdutosIngestOptions() saiu sem fazer nada
    // (hasIntegration ainda false). Agora que a integração foi confirmada,
    // tenta de novo, só se ainda não tiver opções carregadas.
    if (!this.produtosIngestOptions.length) {
      this.loadProdutosIngestOptions();
    }
    this.updateWidgetTypeOptions();
  }

  private clearIntegrationContext(): void {
    this.hasIntegration = false;
    this.integrationPlatform = null;
    this.updateWidgetTypeOptions();
    this.updatePageTypeLabels();
    this.url_store = undefined;
    this.storeEditToken = undefined;
    this.storeEditTokenExpiresAt = undefined;
    this.refreshProductDisplayUrls();
    this.refreshCollectionDisplayUrls();
    this.refreshArticleDisplayUrls();
  }

  private fetchStoreEditToken(): void {
    this.productService.generateStoreEditToken()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          this.storeEditToken = response.token;
          this.storeEditTokenExpiresAt = response.expires_at ?? undefined;
        },
        error: (error) => {
          console.error('Erro ao gerar token temporário da loja:', error);
          // Busca silenciosa de propósito (sem errorHandler.handle/toast), mas
          // ainda reportamos pro PostHog pra não perder visibilidade do erro.
          this.posthogService.captureException(error);
          this.storeEditToken = undefined;
        }
      });
  }

  private normalizeStoreUrl(domain?: string | null): string | undefined {
    if (!domain) {
      return undefined;
    }
    const sanitized = domain.trim().replace(/\/+$/, '');
    if (!sanitized) {
      return undefined;
    }
    if (/^https?:\/\//i.test(sanitized)) {
      return sanitized;
    }
    return `https://${sanitized}`;
  }

  private refreshArticleDisplayUrls(): void {
    const mapper = (article: any) => ({
      ...article,
      displayUrl: this.computeArticleDisplayUrl(article)
    });
    if (this.recentArticles.length) {
      this.recentArticles = this.recentArticles.map(mapper);
    }
    if (this.articlesList.length) {
      this.articlesList = this.articlesList.map(mapper);
    }
    if (this.selectedArticle) {
      this.selectedArticle = mapper(this.selectedArticle);
    }
  }

  private computeArticleDisplayUrl(article: { blogTitle?: string; handle?: string; article_url?: string }): string | null {
    if (this.integrationPlatform === 'nuvemshop') {
      return this.normalizeStoreUrl(article.article_url ?? '') ?? null;
    }
    const baseUrl = this.url_store?.replace(/\/+$/, '');
    if (!baseUrl) {
      return null;
    }
    const blogTitle = article.blogTitle || 'blog';
    const blogSlug = this.slugify(blogTitle);
    const handle = article.handle ?? '';
    return `${baseUrl}/blogs/${blogSlug}/${handle}`;
  }
  private computeProductDisplayUrl(product: { title?: string; product_url?: string }): string | null {
    const payloadUrl = this.normalizeStoreUrl(product.product_url ?? '');
    if (this.integrationPlatform === 'nuvemshop') {
      return payloadUrl ?? null;
    }

    // ✅ Shopify: se veio product_url, ela já contém o handle correto
    if (payloadUrl) return payloadUrl;

    // fallback só se NÃO veio product_url
    const slug = this.slugifyUnicode(product.title ?? '');
    const baseUrl = this.url_store?.replace(/\/+$/, '');
    return (slug && baseUrl) ? `${baseUrl}/products/${slug}` : null;
  }
  slugifyUnicode(text: string | null | undefined): string {
    if (!text) return '';

    return text
      .toLowerCase()
      .normalize('NFD')                    // separa acento da letra
      .replace(/[\u0300-\u036f]/g, '')     // remove acentos
      .replace(/\s+/g, '-')
      .replace(/[^\p{L}\p{N}-]+/gu, '')    // mantém letras/números unicode
      .replace(/--+/g, '-')
      .replace(/^-+|-+$/g, '');
  }


  private computeCollectionDisplayUrl(collection: { handle?: string; collection_url?: string }): string | null {
    const normalizedPayloadUrl = this.normalizeStoreUrl(collection.collection_url ?? '');
    if (this.integrationPlatform === 'nuvemshop') {
      return normalizedPayloadUrl ?? null;
    }
    const handle = collection.handle ?? '';
    const baseUrl = this.url_store?.replace(/\/+$/, '');
    if (handle && baseUrl) {
      return `${baseUrl}/collections/${handle}`;
    }
    return normalizedPayloadUrl ?? null;
  }
  private withProductDisplayData(product: any): any {
    const displayUrl = this.computeProductDisplayUrl(product);
    const fallbackPath = product.pathKey || (product.title ? `/products/${this.slugify(product.title)}` : '');
    const cleanedPath = this.cleanUrl(displayUrl || product.product_url || fallbackPath || '');
    return {
      ...product,
      displayUrl: displayUrl ?? product.displayUrl,
      pathKey: cleanedPath || fallbackPath || ''
    };
  }
  private withCollectionDisplayData(collection: any): any {
    const displayUrl = this.computeCollectionDisplayUrl(collection);
    const fallbackPath = collection.pathKey || (collection.handle ? `/collections/${collection.handle}` : '');
    const cleanedPath = this.cleanUrl(displayUrl || collection.collection_url || fallbackPath || '');
    return {
      ...collection,
      displayUrl: displayUrl ?? collection.displayUrl,
      pathKey: cleanedPath || fallbackPath || ''
    };
  }
  private mapProductResponse(product: any): any {
    return this.withProductDisplayData({
      id: product.id,
      thumbnail: product.thumbnail,
      title: product.title,
      product_url: product.product_url
    });
  }
  private mapCollectionResponse(collection: any): any {
    return this.withCollectionDisplayData({
      id: collection.id,
      title: collection.title,
      handle: collection.handle,
      image: collection.image,
      collection_url: collection.collection_url
    });
  }
  private refreshProductDisplayUrls(): void {
    if (this.recentProducts.length) {
      this.recentProducts = this.recentProducts.map(product => this.withProductDisplayData(product));
    }
    if (this.productsList.length) {
      this.productsList = this.productsList.map(product => this.withProductDisplayData(product));
    }
    if (this.selectedProduct) {
      this.selectedProduct = this.withProductDisplayData(this.selectedProduct);
    }
  }
  private refreshCollectionDisplayUrls(): void {
    if (this.recentCollections.length) {
      this.recentCollections = this.recentCollections.map(collection => this.withCollectionDisplayData(collection));
    }
    if (this.collectionsList.length) {
      this.collectionsList = this.collectionsList.map(collection => this.withCollectionDisplayData(collection));
    }
    if (this.selectedCollection) {
      this.selectedCollection = this.withCollectionDisplayData(this.selectedCollection);
    }
  }

  private getSelectedDisplayUrl(): string | null {
    if (this.selectedPageType === 'produtos') {
      return this.selectedProduct?.displayUrl || null;
    }
    if (this.selectedPageType === 'colecoes') {
      return this.selectedCollection?.displayUrl || null;
    }
    if (this.selectedPageType === 'artigos') {
      return this.selectedArticle?.displayUrl || null;
    }
    if (this.selectedPageType === 'homepage' && this.ss_homepage_url) {
      return this.ss_homepage_url.startsWith('http') ? this.ss_homepage_url : `https://${this.ss_homepage_url}`;
    }
    return null;
  }

  private buildSelectedItemEditUrl(): string | null {
    if (!this.storeEditToken) {
      return null;
    }
    const baseUrl = this.getSelectedDisplayUrl() || this.ss_url_page || null;
    if (!baseUrl) {
      return null;
    }
    try {
      const normalized = new URL(baseUrl);
      normalized.searchParams.set('edition-mode', 'true');
      normalized.searchParams.set('token', this.storeEditToken);
      return normalized.toString();
    } catch {
      const separator = baseUrl.includes('?') ? '&' : '?';
      return `${baseUrl}${separator}edition-mode=true&token=${encodeURIComponent(this.storeEditToken)}`;
    }
  }

  // Handle do app block no Theme App Extension da Shopify, por template do widget.
  private readonly shopifyBlockHandles: Record<string, string> = {
    carousel: 'slicksell-carousel-widget',
    inline: 'slicksell-inline-widget',
    stories: 'slicksell-stories-widget',
    discover: 'slicksell-discover-widget',
  };

  // Template nativo da Shopify por tipo de página selecionado no painel de embedding.
  private readonly shopifyPageTemplates: Record<string, string> = {
    produtos: 'product',
    colecoes: 'collection',
    artigos: 'article',
    homepage: 'index',
  };

  private getSelectedPreviewPath(): string | null {
    if (this.selectedPageType === 'homepage') {
      return '/';
    }
    const displayUrl = this.getSelectedDisplayUrl();
    if (!displayUrl) {
      return null;
    }
    try {
      return new URL(displayUrl).pathname || '/';
    } catch {
      return displayUrl.startsWith('/') ? displayUrl : `/${displayUrl}`;
    }
  }

  private buildShopifyThemeEditorUrl(): string | null {
    if (!this.ss_page || !this.selectedPageType) {
      return null;
    }
    const template = this.shopifyPageTemplates[this.selectedPageType];
    const blockHandle = this.shopifyBlockHandles[this.selectedTemplate];
    if (!template || !blockHandle) {
      return null;
    }

    // Formato da doc oficial de deep link do Theme App Extension, mais previewPath
    // (não documentado nesse combo — a Shopify hoje ignora/sobrescreve esse parâmetro
    // quando usado junto de addAppBlockId, ver https://community.shopify.com/c/extensions/app-block-deep-link-open-theme-editor-in-specific-preview-page/m-p/2273308):
    // https://<myshopifyDomain>/admin/themes/current/editor?template=...&addAppBlockId=...&target=newAppsSection&previewPath=...
    const url = new URL(`https://${this.ss_page}.myshopify.com/admin/themes/current/editor`);
    url.searchParams.set('template', template);
    url.searchParams.set('addAppBlockId', `${environment.shopifyClientId}/${blockHandle}`);
    url.searchParams.set('target', 'newAppsSection');

    const previewPath = this.getSelectedPreviewPath();
    if (previewPath) {
      url.searchParams.set('previewPath', previewPath);
    }

    return url.toString();
  }

  url_store?: string;
  findAndSetSelectedProduct(urlDisplay: string) {
    const target = this.cleanUrl(urlDisplay);
    const applySelection = () => {
      this.selectedProduct = this.productsList.find(product => {
        const pathKey = product.pathKey || this.cleanUrl(product.displayUrl || product.product_url || '');
        return pathKey === target;
      }) || null;
      this.cdr.detectChanges();
    };

    if (!this.productsList.length) {
      // Espera a listagem de produtos carregar antes de buscar
      this.productService.listProducts().subscribe({
        next: (response) => {
          const mappedProducts = response.products.map((product: any) => this.mapProductResponse(product));
          this.recentProducts = mappedProducts;
          this.productsList = [...mappedProducts];
          applySelection();
        },
        error: (error) => {
          console.error('Erro ao carregar produtos:', error);
        }
      });
    } else {
      // Se os produtos já estão carregados, busca diretamente
      applySelection();
    }
  }
  findAndSetSelectedCollection(urlDisplay: string) {
    const target = this.cleanUrl(urlDisplay);
    const applySelection = () => {
      this.selectedCollection = this.collectionsList.find(collection => {
        const pathKey = collection.pathKey || this.cleanUrl(collection.displayUrl || collection.collection_url || '');
        return pathKey === target;
      }) || null;
      this.cdr.detectChanges();
    };

    if (!this.collectionsList.length) {
      this.productService.listCollections().subscribe({
        next: (response) => {
          const mappedCollections = response.collections.map((collection: any) => this.mapCollectionResponse(collection));
          this.recentCollections = mappedCollections;
          this.collectionsList = [...mappedCollections];
          applySelection();
        },
        error: (error) => {
          console.error('Erro ao carregar coleções:', error);
        }
      });
    } else {
      applySelection();
    }
  }
  findAndSetSelectedArticle(urlDisplay: string) {
    if (!this.articlesList.length) {
      this.productService.listArticles().subscribe({
        next: (response) => {
          this.articlesList = response.articles.map((article: any) => ({
            title: article.title,
            handle: article.handle,
            image: article.image,
            blogTitle: article.blog?.title,
            article_url: article.article_url,
            displayUrl: this.computeArticleDisplayUrl({
              blogTitle: article.blog?.title,
              handle: article.handle,
              article_url: article.article_url
            })
          }));

          const target = this.cleanUrl(urlDisplay);
          this.selectedArticle = this.articlesList.find(article =>
            this.cleanUrl(article.displayUrl || '') === target
          ) || null;

          this.cdr.detectChanges();
          setTimeout(() => this.attachAssetsPickListScrollListener(), 0);
        },
        error: (error) => {
          console.error('Erro ao carregar artigos:', error);
        }
      });
    } else {
      const target = this.cleanUrl(urlDisplay);
      this.selectedArticle = this.articlesList.find(article =>
        this.cleanUrl(article.displayUrl || '') === target
      ) || null;

      this.cdr.detectChanges();
    }
  }

  recentProducts: any[] = [];
  recentCollections: any[] = [];
  recentArticles: any[] = [];
  productsList: any[] = [];
  collectionsList: any[] = [];
  articlesList: any[] = [];
  listarProducts() {
    this.productService.listProducts().subscribe({
      next: (response) => {
        this.recentProducts = response.products.map((product: any) => this.mapProductResponse(product));
        this.productsList = [...this.recentProducts]; // Inicializa com todos os produtos
      },
      error: (error) => {
        console.error('Erro ao carregar produtos:', error);
      }
    });
  }
  listarCollections() {
    this.productService.listCollections().subscribe({
      next: (response) => {
        this.recentCollections = response.collections.map((collection: any) => this.mapCollectionResponse(collection));
        this.collectionsList = [...this.recentCollections];
      },
      error: (error) => {
        console.error('Erro ao carregar coleções:', error);
      }
    });
  }
  listarArticles() {
    this.productService.listArticles().subscribe({
      next: (response) => {
        this.recentArticles = response.articles.map((article: any) => ({
          id: article.id ?? null,
          title: article.title ?? 'Título não disponível',
          handle: article.handle ?? '',
          image: article.image ?? 'assets/images/default-article.png', // Imagem padrão se não existir
          blogTitle: article.blog?.title ?? 'Blog desconhecido', // Nome do blog ou valor padrão
          article_url: article.article_url ?? '',
          displayUrl: this.computeArticleDisplayUrl({
            blogTitle: article.blog?.title ?? 'Blog desconhecido',
            handle: article.handle ?? '',
            article_url: article.article_url ?? ''
          })
        }));
        this.articlesList = [...this.recentArticles];
        this.refreshArticleDisplayUrls();
      },
      error: (error) => {
        console.error('Erro ao carregar artigos:', error);
      }
    });
  }

  hasIntegration: boolean = false;
  filteredTemplates: any[] = [...this.templates];
  capitalizeFirstLetter(text: string | undefined): string {
    if (!text) return '';
    return text.charAt(0).toUpperCase() + text.slice(1);
  }
  async onFeedTypeChange(newType: string) {
    await this.editWidget(0);
    this.selectedWidgetType = newType;
    if (newType === 'manual') {
      this.initializeObserver();
    } else {
      if (this.observer) {
        this.observer.disconnect();
      }
    }
    this.filteredTemplates = [...this.templates];
    // Se o template atual for desabilitado pela nova seleção, redefinir o template.
    if (this.isTemplateDisabled(this.selectedTemplate)) {
      this.selectedTemplate = ''; // Limpa a seleção.
    }
    // Resetar a seleção do radioButton se o template atual não for permitido
    if (!this.filteredTemplates.some(template => template.key === this.selectedTemplate)) {
      this.selectedTemplate = '';
    }
    // **Aqui definimos automaticamente o template conforme o feed selecionado**
    if (newType === 'fullfeed') {
      this.selectedTemplate = 'iframe';

      // 🔥 Agora além de setar, também chamamos onResolutionChange
      if (this.resolutions && this.resolutions.length > 0) {
        this.selectedResolution = this.resolutions[0].value;
        this.onResolutionChange(this.selectedResolution); // Chama o método com a resolução inicial
      }
    } else {
      this.selectedTemplate = 'carousel';
    }
    if (newType === 'feeds') {
      this.feedService.listFeeds(15, undefined).subscribe({
        next: (res: any) => {
          const feeds = res.feeds || [];

          this.feedsOptions = feeds.map((feed: any) => ({
            title: feed.title,
            value: feed.uid,
            uid: feed.uid,
            source_id: feed.source_id,
            feed_type: feed.feed_type,
            hashtag_name: feed.hastag_name,
            type: feed.type,
            published_count: feed.published_count,
          }));
        },
        error: err => {
          console.error('Erro ao carregar feeds:', err);
        }
      });
    }
    if (newType === 'produtos' && !this.produtosIngestOptions.length) {
      this.loadProdutosIngestOptions();
    }

  }
  getSecondaryTypes(typeStr: string | undefined): string[] {
    if (!typeStr) {
      return [];
    }
    return typeStr
      .split(',')
      .map(t => t.trim())
      .filter(t => !t.startsWith('#'));
  }
  getUnicodeIcon(tag: string): string {
    const t = tag.trim().toLowerCase();
    if (t.startsWith('#')) {
      return '#';                // ou '🔀', '🔖'…
    }
    if (t === 'imagens' || t === 'image') {
      return '🖼️';
    }
    if (t === 'vídeos' || t === 'videos' || t == 'video') {
      return '🎞️';
    }
    if (t === 'stories') {
      return '▯';                // U+25AF, retângulo
    }
    if (t === 'reels' || t === 'reel') {
      return '▶️';               // U+25B6, “play”
    }
    if (t === 'tag' || t === 'Tag') {
      return '🏷';               // U+25B6, “play”
    }
    if (t === 'personal_media') {
      return '🗂️';               // U+25B6, “play”
    }
    return '';                   // sem ícone
  }
  getTypeSeverity(type: string): string {
    switch (type) {
      case 'IMAGE': return 'info';
      case 'VIDEO': return 'help';
      case 'REEL': return 'warning';
      case 'CAROUSEL_ALBUM': return 'success';
      default: return 'secondary';
    }
  }
  getSourceIconClass(sourceId: string): string {
    switch (sourceId) {
      case 'ig': return 'pi pi-instagram';
      case 'yt': return 'pi pi-youtube';
      case 'tt': return 'pi pi-video'; // ou outro ícone se tiver TikTok customizado
      case 'uploads': return 'pi pi-upload';
      default: return 'pi pi-question';
    }
  }

  feedsOptions: FeedOption[] = [];
  selectedFeeds: string[] = [];

  // Ingest por produtos: multiSelect do catálogo da loja. Cada produto selecionado vira
  // uma tag fixa `product_{id}` (mesmo esquema usado em slick-detail, ver [[feature_product_locked_tags]]),
  // salva no MESMO campo `tags` (pipe-separated) que o modo 'tags' já usa — o backend
  // trata 'produtos' de forma idêntica a 'tags' no matching (LiveShopController).
  produtosIngestOptions: { value: number; name: string; thumbnail: string; price: string }[] = [];
  selectedProdutosIngest: number[] = [];

  private getTagsToSave(): string {
    if (this.selectedWidgetType === 'produtos') {
      return (this.selectedProdutosIngest || []).map(id => `product_${id}`).join('|');
    }
    return this.valuesSlicksTags ? this.valuesSlicksTags.join('|') : '';
  }

  private loadProdutosIngestOptions(): void {
    // Sem integração ativa (Shopify/Nuvemshop) não existe catálogo pra buscar —
    // chamar listProducts() nesse caso só gera 500 no backend (loja sem
    // store_app de ecommerce). hasIntegration vem de loadIntegrationInfo().
    if (!this.hasIntegration) {
      return;
    }
    this.productService.listProducts().subscribe({
      next: (response: any) => {
        this.produtosIngestOptions = (response.products || []).map((product: any) => ({
          value: product.id,
          name: product.title ?? product.name,
          thumbnail: product.thumbnail,
          price: product.price
        }));
      },
      error: (error) => {
        console.error('Erro ao carregar produtos para ingest:', error);
      }
    });
  }
  isTemplateDisabled(templateKey: string): boolean {
    if (this.selectedWidgetType === 'fullfeed') {
      // Desabilita todas as opções exceto 'iframe'
      return templateKey !== 'iframe';
    } else {
      // Desabilita apenas 'iframe'
      return templateKey === 'iframe';
    }
  }
  breadcrumbItems: any[];
  navigateToConfigurations(): void {
    this.router.navigate(['/configurations']);
  }
  navigateToIntegrations(): void {
    // Navega para configurações com a aba Integrações ativa
    this.router.navigate(['/configurations'], { queryParams: { tab: 'integrations' } });
  }

  navigateToDomains(): void {
    // Navega para configurações com Integrações ativa e foca nos Domínios Permitidos
    this.router.navigate(['/configurations'], { queryParams: { tab: 'integrations', focus: 'domains' } });
  }
  openSidebar(): void {
    this.displaySidebar = true;
  }
  onResolutionChange(resolution: { width: number; height: number }) {
    if (resolution) {
      this.height = resolution.height;
      this.aspectRatio = `${resolution.width} / ${resolution.height}`;
    }
  }
  onTemplateSelected(newTemplate: string) {
    this.hasErrorUrlDisplay = false;
    this.selectedTemplate = newTemplate;
    if ((newTemplate === 'inline' || newTemplate === 'iframe') && !this.selectedResolution) {
      this.selectedResolution = this.resolutions[2]?.value ?? this.resolutions[0]?.value;
      this.onResolutionChange(this.selectedResolution);
    }
    this.updateWidgetShare();
    this.loadDisabledItems(this.selectedPageType);
  }
  updateWidgetShare() {
    let loja: string = '';
    const domainStore = localStorage.getItem('domain_store');

    if (domainStore) {
      const match = domainStore.match(/^([^\.]+)\./);
      loja = match ? match[1] : '';
    }

    let width = 100;
    if (this.selectedTemplate === 'iframe') {
      if (this.aspectRatio && this.height) {
        const [ratioWidth, ratioHeight] = this.aspectRatio.split('/').map(Number);
        width = this.height * (ratioWidth / ratioHeight);
      }
      this.widget_share = `<iframe src="${environment.frontendUrl}/${loja}" frameborder="0" width="${width}" height="${this.height}"></iframe>`;
    } else {
      if (this.aspectRatio && this.height) {
        const [ratioWidth, ratioHeight] = this.aspectRatio.split('/').map(Number);
        width = this.height * (ratioWidth / ratioHeight);
      }
      this.widget_share = `<slicksell-widget class="ss-H889djhd6Jjk" template-type="${this.selectedTemplate}" store-id=${this.store_id} widget-id=${this.widget_id}></slicksell-widget>`;
    }
  }
  loadDisabledItems(pageType: string | null) {
    this.showSearchButton = true;
    this.widgetService.filterWidgetsByPageType(pageType, this.selectedTemplate, this.currentWidgetUid).subscribe({
      next: (widgets) => {
        const disabledUrls = widgets
          .filter(widget => widget.url_display)
          .map(widget => this.cleanUrl(widget.url_display));


        switch (pageType) {
          case 'produtos':
            this.disabledProducts = disabledUrls;
            break;

          case 'colecoes':
            this.disabledCollections = disabledUrls;
            break;

          case 'artigos':
            this.disabledArticles = disabledUrls;
            break;

          default:
            console.warn('Tipo de página não reconhecido:', pageType);
        }
      },
      error: (error) => {
        console.error(`Erro ao buscar widgets (${pageType}):`, error);
      }
    });
  }

  pageTypes = [
    { label: 'Produtos', value: 'produtos' },
    { label: 'Coleções', value: 'colecoes' },
    { label: 'Artigos', value: 'artigos' },
    //{ label: 'Outras', value: 'outras' },
    { label: 'Homepage', value: 'homepage' }
  ];

  private updatePageTypeLabels(): void {
    const isNuvemshop = this.integrationPlatform === 'nuvemshop';
    this.pageTypes[1].label = isNuvemshop ? 'Categorias' : 'Coleções';
    this.pageTypes[2].label = isNuvemshop ? 'Páginas' : 'Artigos';
  }
  // Opção selecionada
  selectedPageType: string | null = null;
  disabledProducts: string[] = [];
  disabledCollections: string[] = [];
  disabledArticles: string[] = [];
  showSearchButton: boolean = false;
  selectedProduct: any = null;
  get hasSelectedPageItem(): boolean {
    if (this.integrationPlatform === 'shopify') {
      // Nuvemshop usa o token JWT do editor de posicionamento (Tiendanube HTML Editor);
      // Shopify abre o Theme Editor nativo via deep link (themes/current), então basta
      // ter o domínio da loja resolvido, sem depender do theme_id.
      if (!this.ss_page) {
        return false;
      }
      if (this.selectedPageType === 'produtos') {
        return !!this.selectedProduct;
      }
      if (this.selectedPageType === 'colecoes') {
        return !!this.selectedCollection;
      }
      if (this.selectedPageType === 'artigos') {
        return !!this.selectedArticle;
      }
      if (this.selectedPageType === 'homepage') {
        return !!this.ss_page;
      }
      // Outras ainda não tem um template Shopify confiável para o deep link.
      return false;
    }

    if (this.selectedPageType === 'produtos') {
      return !!this.selectedProduct && !!this.storeEditToken;
    }
    if (this.selectedPageType === 'colecoes') {
      return !!this.selectedCollection && !!this.storeEditToken;
    }
    if (this.selectedPageType === 'artigos') {
      return !!this.selectedArticle && !!this.storeEditToken;
    }
    if (this.selectedPageType === 'homepage') {
      return !!this.ss_page;
    }
    return this.selectedPageType === 'outras' ? !!this.ss_url_page && !!this.storeEditToken : false;
  }
  handleOpenList() {
    if (this.selectedPageType === 'produtos') {
      this.openProductsList();
    } else if (this.selectedPageType === 'colecoes') {
      this.openCollectionsList();
    } else if (this.selectedPageType === 'artigos') {
      this.openArticlesList();
    }
  }

  clearSelection(event: Event) {
    event.stopPropagation(); // para não reabrir a listagem ao clicar no botão de remover
    this.hasErrorUrlDisplay = false;
    if (this.selectedPageType === 'produtos') {
      this.selectedProduct = null;
    } else if (this.selectedPageType === 'colecoes') {
      this.selectedCollection = null;
    } else if (this.selectedPageType === 'artigos') {
      this.selectedArticle = null;
    }
  }

  addProductToChips2(product: any) {
    if (!this.isProductDisabled(product)) {
      this.selectedProduct = this.withProductDisplayData(product); // Armazena o produto selecionado
      this.displayCommandMenu = false; // Fecha o `p-dialog` após seleção
      this.hasErrorUrlDisplay = false;
      console.log("Produto selecionado:", this.selectedProduct);
    }
  }
  openProductsList() {
    console.log("Abrindo lista de produtos...");

    this.listarProducts(); // 🔥 Agora carregamos os produtos aqui
    this.displayCommandMenu = true; // Abre o p-dialog
  }
  openCollectionsList() {
    this.listarCollections();
    this.displayCollectionsMenu = true;
  }
  // Verificar se uma coleção está desabilitada
  isCollectionDisabled(collection: any): boolean {
    const collectionUrl = collection?.pathKey || this.cleanUrl(collection?.displayUrl || collection?.collection_url || '');
    return collectionUrl ? this.disabledCollections.includes(collectionUrl) : false;
  }

  // Verificar se um artigo está desabilitado
  isArticleDisabled(article: any): boolean {
    if (!article || !article.title) {
      return true; // Se não houver artigo ou título, considera desabilitado
    }
    const articleUrl = this.cleanUrl(article.displayUrl || '');
    return this.disabledArticles.includes(articleUrl);
  }
  // Abrir P-Dialog de Artigos
  openArticlesList() {
    this.listarArticles();
    this.displayArticlesMenu = true;
  }
  // Adicionar uma coleção selecionada
  selectedCollection: any = null;
  addCollectionToChips(collection: any) {
    this.selectedCollection = this.withCollectionDisplayData(collection);
    this.displayCollectionsMenu = false;
    this.hasErrorUrlDisplay = false;
  }

  // Adicionar um artigo selecionado
  selectedArticle: any = null;
  addArticleToChips(article: any) {
    this.selectedArticle = {
      ...article,
      displayUrl: article.displayUrl || this.computeArticleDisplayUrl(article)
    };
    this.displayArticlesMenu = false;
    this.hasErrorUrlDisplay = false;


  }
  @ViewChild('selectButtonRef', { static: false, read: ElementRef }) selectButtonRef!: ElementRef;

  displayEditDialog: boolean = false;
  templateUidToEdit?: string;
  // Método que será chamado ao selecionar uma opção
  onPageTypeChange(selectedValue: string) {
    this.hasErrorUrlDisplay = false;
    // 🔥 Limpa os conteúdos anteriores ao mudar o tipo de página
    this.selectedProduct = null;
    this.selectedCollection = null;
    this.selectedArticle = null;

    // Bug real corrigido: o rule-builder (app-rule-group, ruleTree) só é
    // exibido/editável quando selectedPageType === 'outras' (ver
    // edit-widget-store-panel.component.html:143-152), mas antes disso
    // continuava sendo salvo (url_rules: [this.ruleTree]) mesmo depois do
    // usuário trocar pra Produtos/Coleções/Artigos/Homepage — o backend
    // (checkWidgetPublicAuthorization) dá prioridade a widget_rule.url_rules
    // sobre url_display sempre que ele existir, então uma regra antiga
    // "órfã" (invisível na UI, mas ainda salva) bloqueava o acesso mesmo
    // com o url_display novo correto. Resetar aqui garante que trocar de
    // tipo de página limpa de vez qualquer regra manual anterior.
    if (selectedValue !== 'outras') {
      this.ruleTree = createEmptyGroup();
    }

    this.showSearchButton = false;

    console.log('Tipo de página selecionado:', selectedValue);
    this.showSearchButton = false;
    if (selectedValue === 'produtos' || selectedValue === 'colecoes' || selectedValue === 'artigos') {
      // Mantém todas as opções, mas vamos desabilitar "Contém" via classe
      this.filteredConditionOptions = [...this.conditionOptions];

      // Se "Contém" estava selecionado, muda para "Igual"
      if (this.selectedCondition === 'contem') {
        this.selectedCondition = 'igual';
      }

      // Adiciona a classe na opção "Contém"
      //this.highlightContainOption();
    } else {
      // Caso contrário, restaura todas as opções
      this.filteredConditionOptions = [...this.conditionOptions];
      // 🔥 Agora removemos a classe "disabled-option"
      if (!this.selectButtonRef || !this.selectButtonRef.nativeElement) return;
      const buttons = this.selectButtonRef.nativeElement.querySelectorAll('span.p-button-label');
      buttons.forEach((button: HTMLElement) => {
        button.parentElement?.classList.remove('disabled-option'); // Remove a classe
      });
    }
    let template = this.selectedTemplate;
    this.showSearchButton = false;
    switch (selectedValue) {
      case 'produtos':
        //productsList
        console.log('Executando ação para Produtos');
        this.widgetService.filterWidgetsByPageType(selectedValue, template, this.currentWidgetUid).subscribe({
          next: (widgets) => {
            console.log('Widgets filtrados:', widgets);
            // Aqui você pode armazenar os widgets retornados ou realizar outra ação
            // Atualiza a lista de produtos desabilitados com base nas URLs retornadas
            this.disabledProducts = widgets
              .filter(widget => widget.url_display) // Remove valores null
              .map(widget => this.cleanUrl(widget.url_display));

            //console.log('URLs desabilitadas:', this.disabledProducts);
            // ✅ Agora que temos os widgets desabilitados, carregamos os produtos
            this.showSearchButton = true;
          },
          error: (error) => {
            console.error('Erro ao buscar widgets:', error);
          }
        });
        // Adicione ações específicas para Produtos aqui
        break;

      case 'colecoes':
        console.log('Executando ação para Coleções');
        this.widgetService.filterWidgetsByPageType(selectedValue, template, this.currentWidgetUid).subscribe({
          next: (widgets) => {
            console.log('widgets: ', widgets)

            this.disabledCollections = widgets
              .filter(widget => widget.url_display)
              .map(widget => this.cleanUrl(widget.url_display));

            console.log('URLs desabilitadas:', this.disabledCollections);
            this.showSearchButton = true;
          },
          error: (error) => {
            console.error('Erro ao buscar widgets:', error);
          }
        });
        break;

      case 'artigos':
        console.log('Executando ação para Artigos');
        this.widgetService.filterWidgetsByPageType(selectedValue, template, this.currentWidgetUid).subscribe({
          next: (widgets) => {
            this.disabledArticles = widgets
              .filter(widget => widget.url_display)
              .map(widget => this.cleanUrl(widget.url_display));

            console.log('URLs desabilitadas:', this.disabledArticles);
            this.showSearchButton = true;
          },
          error: (error) => {
            console.error('Erro ao buscar widgets:', error);
          }
        });
        break;

      case 'outras':
        console.log('Executando ação para Outras');
        // Adicione ações específicas para Outras aqui
        break;

      case 'homepage':
        console.log('Executando ação para Homepage');
        break;

      default:
        console.log('Nenhuma ação definida para esta opção');
    }
  }
  cleanUrl(url: string): string {
    if (!url) {
      return '';
    }
    const trimmed = url.trim();
    const withoutProtocol = trimmed.replace(/^https?:\/\//i, '');
    const slashIndex = withoutProtocol.indexOf('/');
    return slashIndex >= 0 ? withoutProtocol.slice(slashIndex) : '';
  }
  highlightContainOption() {
    setTimeout(() => {
      if (!this.selectButtonRef || !this.selectButtonRef.nativeElement) {
        console.warn('Elemento selectButtonRef ainda não está disponível.');
        return;
      }

      // Procura os botões dentro do p-selectButton
      const buttons = this.selectButtonRef.nativeElement.querySelectorAll('span.p-button-label');

      if (!buttons.length) {
        console.warn('Nenhum botão encontrado dentro do p-selectButton.');
        return;
      }

      buttons.forEach((button: HTMLElement) => {
        console.log('innerText:', button.innerText);

        if (button.innerText.includes('Contém')) {
          button.parentElement?.classList.add('disabled-option'); // Adiciona classe de desabilitado
        } else {
          button.parentElement?.classList.remove('disabled-option'); // 🔥 Remove a classe se não for "Contém"
        }
      });
    }, 200); // Ajuste o tempo conforme necessário
  }

  displayCollectionsMenu = false;
  displayArticlesMenu = false;
  limitChips() {
    if (this.selectedPageType === 'colecoes' || this.selectedPageType === 'artigos') {
      if (this.valuesEqualTags.length > 1) {
        this.valuesEqualTags.pop(); // Remove o último item adicionado para manter apenas 1
      }
    }
  }
  redirectToEditWidget() {
    if (this.templateUidToEdit) {
      window.location.href = `${window.location.origin}/edit_widgets/${this.templateUidToEdit}`;
    }
  }

  // Função para slugificar o título do produto
  slugify(text: string | null | undefined): string {
    if (!text) return ''; // Retorna string vazia se for nulo ou indefinido

    return text.toString().toLowerCase()
      .replace(/\s+/g, '-')   // Substitui espaços por hífens
      .replace(/[^\w\-]+/g, '')  // Remove caracteres especiais
      .replace(/\-\-+/g, '-') // Substitui múltiplos hífens por um único
      .replace(/^-+/, '')  // Remove hífens do início
      .replace(/-+$/, '');  // Remove hífens do final
  }

  isProductDisabled(product: any): boolean {
    const productUrl = product?.pathKey || this.cleanUrl(product?.displayUrl || product?.product_url || '');
    return productUrl ? this.disabledProducts.includes(productUrl) : false;
  }
  visible: boolean = false;

  position: string = 'center';
  dragDrop(x: number, event?: Event) {
    if (event) {
      event.stopPropagation(); // Previne que o clique se propague e desative o drag and drop
    }

    if (x === 0) {
      this.isDragDrop = true;
    } else {
      this.isDragDrop = false;
    }
  }
  async onReorder(event: any) {
    console.log('reordenou')
    this.isDragDrop = false;

    const { items, listType } = event;

    await this.editWidget(0);
  }
  showEqualClearFunction() { this.showClearEqualTags = this.widgetHelperService.showClearFunction(this.valuesEqualTags); }
  showContainClearFunction() { this.showClearContainTags = this.valuesContainTags.length > 0; }
  clearEqualTags() { this.valuesEqualTags = []; this.showClearEqualTags = false; }
  clearContainTags() { this.valuesContainTags = []; this.showClearContainTags = false; }
  isCol4: boolean = false;
  private containerHeightLockRaf: number | null = null;

  private withContainerHeightLock(action: () => void): void {
    const el = this.containerDivRef?.nativeElement;
    if (!el) {
      action();
      return;
    }

    if (this.containerHeightLockRaf != null) {
      cancelAnimationFrame(this.containerHeightLockRaf);
      this.containerHeightLockRaf = null;
    }

    const prevMinHeight = el.style.minHeight;
    const h = Math.round(el.getBoundingClientRect().height);
    if (h > 0) {
      el.style.minHeight = `${h}px`;
    }

    action();

    // Libera após o layout estabilizar (2 frames) para evitar flick da scrollbar.
    this.containerHeightLockRaf = requestAnimationFrame(() => {
      this.containerHeightLockRaf = requestAnimationFrame(() => {
        this.containerHeightLockRaf = null;
        if (prevMinHeight) {
          el.style.minHeight = prevMinHeight;
        } else {
          el.style.removeProperty('min-height');
        }
      });
    });
  }
  changeLandscape() {
    this.withContainerHeightLock(() => {
      this.widgetHelperService.changeLandscapeLayout(this.valSelect1Video, this.containerDivRef, this.renderer);
      this.isCol4 = this.containerDivRef.nativeElement.classList.contains('col-4');
    });
    // Troca de device (Desktop/Mobile): o painel de Espaçamento passa a
    // ler/escrever no outro conjunto de campos — recalcula os toggles de
    // âncora pra refletir o device recém-selecionado.
    this.refreshSpacingLinkFlags();
  }
  copiarScript() {
    console.log('Chamou copiarScript'); // ✅ DEBUG
    if (this.script_share) {
      navigator.clipboard.writeText(this.script_share).then(() => {
        console.log('Texto copiado:', this.script_share); // ✅ DEBUG
        this.messageService.add({
          severity: 'success',
          summary: 'Copiado!',
          detail: 'Código copiado para a área de transferência',
        });
      }).catch((error) => {
        this.errorHandler.handle(error, 'Não foi possível copiar o texto');
      });
    }
  }

  copiarWidget() { if (this.widget_share) { this.widgetHelperService.copiarTextoParaClipboard(this.widget_id.toString()); } }

  listAssets(typeSlick: string | undefined = undefined, limitOverride?: number): Observable<void> { // parte 1
    this.resetAssetsPagination(typeSlick, limitOverride);

    console.log('valor final ')
    console.log(this.assetsPageLimit)

    return this.widgetService.getAssets(typeSlick, this.assetsPage, this.assetsPageLimit, this.widget_uid).pipe(
      map((res: AssetsResponse) => { // laast
        const assets = res.assets || [];
        this.sourceProducts = assets.flatMap((asset: { items: any[] }) =>
          asset.items
            .filter((item: any) => item.media?.status === 1) // 👈 apenas status 1
            .map((item: any) => ({
              id: item.content.id,
              uid: item.content.uid,
              title: item.content.title ?? "Título",
              type: item.media.type ?? "Slick",
              thumbnail: item.media.thumbnail == null ? 'assets/imgTmp.webp' : item.media.thumbnail,
              src: item.media.src,
              description: item.content.description,
              caption: (item as any)?.caption ?? (item as any)?.content?.caption ?? null,
              duration: item.media.duration
            }))
        );

        const targetIds = new Set((this.targetProducts || []).map(p => p?.id));
        this.sourceProducts = (this.sourceProducts || []).filter(p => !targetIds.has(p.id));

        this.updateAssetsPaginationFromResponse(res);
        this.cdr.detectChanges();
        setTimeout(() => this.attachAssetsPickListScrollListener(), 0);
      })
    );
  }

  private resetAssetsPagination(filter?: string, limitOverride?: number): void {
    this.currentAssetsFilter = filter;
    this.assetsPage = 1;
    this.assetsNextPage = null;
    this.assetsHasNextPage = false;
    this.assetsIsLoadingMore = false;
    this.assetsPageLimit = (Number.isFinite(limitOverride as number) && (limitOverride as number) > 0)
      ? Math.floor(limitOverride as number)
      : this.assetsLimit;
  }

  private updateAssetsPaginationFromResponse(res: AssetsResponse): void {
    const nextPage = (res as any)?.nextPage;
    const page = (res as any)?.page;
    const totalAssets = (res as any)?.totalAssets;

    this.assetsNextPage = (typeof nextPage === 'number' || nextPage === null) ? nextPage : null;
    if (typeof page === 'number') {
      this.assetsPage = page;
    }

    if (this.assetsNextPage !== null) {
      this.assetsHasNextPage = true;
      return;
    }

    if (typeof totalAssets === 'number') {
      this.assetsHasNextPage = (this.assetsPage * this.assetsPageLimit) < totalAssets;
    } else {
      this.assetsHasNextPage = false;
    }
  }

  private attachAssetsPickListScrollListener(): void {
    this.detachAssetsPickListScrollListener();

    const sourceList = this.getPickListSourceListElement();
    if (!sourceList) return;

    this.pickListSourceScrollHandler = (event: Event) => this.onPickListSourceScroll(event);
    sourceList.addEventListener('scroll', this.pickListSourceScrollHandler, { passive: true } as any);
    this.pickListSourceScrollEl = sourceList;
  }

  private detachAssetsPickListScrollListener(): void {
    if (this.pickListSourceScrollEl && this.pickListSourceScrollHandler) {
      this.pickListSourceScrollEl.removeEventListener('scroll', this.pickListSourceScrollHandler);
    }
    this.pickListSourceScrollEl = undefined;
    this.pickListSourceScrollHandler = undefined;
  }

  private getPickListSourceListElement(): HTMLElement | null {
    const host = this._assetsPickListRef?.nativeElement;
    if (!host) return null;

    return (host.querySelector('.p-picklist-source .p-picklist-list') as HTMLElement)
      || (host.querySelector('.p-picklist-list') as HTMLElement)
      || null;
  }

  private scrollSourceListToBottom(): void {
    const sourceList = this.getPickListSourceListElement();
    if (!sourceList) return;

    setTimeout(() => {
      sourceList.scrollTop = sourceList.scrollHeight;
    }, 0);
  }

  private onPickListSourceScroll(event: Event): void {
    const el = event.target as HTMLElement;
    const padding = 30;
    const isNearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - padding;

    if (isNearBottom) {
      this.loadMoreAssets();
    }
  }

  private mapAssetsToPickListItems(res: AssetsResponse): any[] {
    const assets = res?.assets || [];
    return assets.flatMap((asset: { items: any[] }) =>
      (asset.items || [])
        .filter((item: any) => item.media?.status === 1)
        .map((item: any) => {
          const caption = item?.caption ?? item?.content?.caption ?? null;
          return {
            id: item.content.id,
            uid: item.content.uid,
            title: item.content.title ?? "Título",
            type: item.media.type ?? "Slick",
            thumbnail: item.media.thumbnail == null ? 'assets/imgTmp.webp' : item.media.thumbnail,
            src: item.media.src,
            description: item.content.description ?? null,
            caption,
            duration: item.media.duration
          };
        })
    );
  }

  private addLoadingPlaceholder(): void {
    if ((this.sourceProducts || []).some((p: any) => p?.__loading)) return;

    this.sourceProducts = [
      ...(this.sourceProducts || []),
      this.assetsLoadingSentinel,
      this.assetsLoadingSentinel,
      this.assetsLoadingSentinel
    ];
    this.scrollSourceListToBottom();
    this.cdr.detectChanges();
  }

  private removeLoadingPlaceholder(): void {
    this.sourceProducts = (this.sourceProducts || []).filter((p: any) => !p?.__loading);
  }

  private loadMoreAssets(): void {
    if (!this.assetsHasNextPage || this.assetsIsLoadingMore) return;

    const nextPage = this.assetsNextPage ?? (this.assetsPage + 1);
    if (!Number.isFinite(nextPage) || nextPage <= this.assetsPage) return;

    this.assetsIsLoadingMore = true;
    this.addLoadingPlaceholder();

    this.widgetService.getAssets(this.currentAssetsFilter, nextPage, this.assetsPageLimit, this.widget_uid)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: AssetsResponse) => {
          this.removeLoadingPlaceholder();

          const incoming = this.mapAssetsToPickListItems(res);
          const targetIds = new Set((this.targetProducts || []).map(p => p?.id));
          const existingIds = new Set((this.sourceProducts || []).map(p => p?.id));

          this.sourceProducts = [
            ...(this.sourceProducts || []),
            ...incoming.filter(p => !targetIds.has(p.id) && !existingIds.has(p.id))
          ];

          this.updateAssetsPaginationFromResponse(res);
          this.assetsIsLoadingMore = false;
          this.cdr.detectChanges();
        },
        error: (_err: any) => {
          this.removeLoadingPlaceholder();
          this.assetsIsLoadingMore = false;
          this.assetsHasNextPage = false;
          this.cdr.detectChanges();
        }
      });
  }

  isUuid(value: string): boolean { const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i; return uuidRegex.test(value); }
  onSlickTypeChange(event: any) {
    this.loading = true; let filter = ''; const selectedValue = event.value || this.selectedSlickType;
    switch (selectedValue) {
      case 'todos': filter = 'all'; break;
      case 'shorts': filter = 'shorts'; break;
      case 'live': filter = 'live'; break;
      case 'spots': filter = 'spots'; break;
      case 'photo': filter = 'photo'; break;
      case 'foto': filter = 'photo'; break;
      default: filter = 'all';
    }
    if (filter) {
      const desiredLimit = this.assetsLimit + (this.targetProducts?.length ?? 0);
      this.resetAssetsPagination(filter, desiredLimit);
      this.widgetService.getAssets(filter, this.assetsPage, this.assetsPageLimit, this.widget_uid).pipe(takeUntil(this.destroy$)).subscribe({
        next: (res: AssetsResponse) => {
          const assets = res.assets || [];
          this.loading = false;
          // Obtendo os IDs dos produtos já em `targetProducts` para evitar duplicação
          const targetProductIds = new Set(this.targetProducts.map(product => product.id));

          // Filtrando os produtos de `sourceProducts`, excluindo os que já estão em `targetProducts`
          this.sourceProducts = assets.flatMap((asset: { items: any[] }) =>
            asset.items
              .map((item: any) => ({
                id: item.content.id,
                uid: item.content.uid,
                title: item.content.title ?? "Título",
                type: item.media.type ?? "Slick",
                thumbnail: item.media.thumbnail ?? 'assets/imgTmp.webp',
                description: (item as any)?.content?.description ?? null,
                caption: (item as any)?.caption ?? (item as any)?.content?.caption ?? null,
              }))
              // Excluindo produtos que já estão no `targetProducts`
              .filter(product => !targetProductIds.has(product.id))
          );

          this.updateAssetsPaginationFromResponse(res);
          this.cdr.detectChanges();
          setTimeout(() => this.attachAssetsPickListScrollListener(), 0);
        },
        error: (err) => { this.loading = false; }
      });
    } else { this.loading = false; }
  }
  isCompactView = false;
  @HostListener('window:resize')
  onWindowResize() { this.isCompactView = window.innerWidth < 992; this.updateLayoutMaxHeight(); }

  @ViewChild('configPanelSlot') configPanelSlotRef?: ElementRef<HTMLDivElement>;
  // Altura compartilhada pela área de prévia e pelo painel de configurações
  // (desktop): ambos ficam com a MESMA altura, capada pra caber entre o topo
  // do layout e o rodapé/fim da viewport, com scroll interno próprio quando o
  // conteúdo é maior. Substituiu o mecanismo antigo de "virar position:fixed
  // ao rolar a página" — mais simples e evita os dois lados desalinharem.
  layoutMaxHeightPx: number | null = null;
  private readonly layoutBottomGap = 16; // 1rem

  @HostListener('window:scroll')
  onWindowScrollForLayout(): void {
    this.updateLayoutMaxHeight();
  }

  private updateLayoutMaxHeight(): void {
    const slot = this.configPanelSlotRef?.nativeElement;
    if (!slot || this.isCompactView) {
      return;
    }

    const rect = slot.getBoundingClientRect();

    // Não deixa o layout ultrapassar o footer global da página nem a altura da viewport.
    const footerTop = document.querySelector('footer')?.getBoundingClientRect().top;
    const bottomY = typeof footerTop === 'number'
      ? Math.min(window.innerHeight - this.layoutBottomGap, footerTop - this.layoutBottomGap)
      : window.innerHeight - this.layoutBottomGap;

    this.layoutMaxHeightPx = Math.max(200, bottomY - rect.top);
  }
  isMobileDevice() { const isMobileUA = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent); const isTouchCapable = navigator.maxTouchPoints > 0; return isMobileUA || isTouchCapable; }
  selecionarOpcao(opcao: number): void { this.activeOption = opcao; }
  verificarEExecutar(opcao: number) {
    this.activeOption = opcao;
    // Verifica se o tipo de página exige a ação
    // if (this.selectedPageType === 'produtos' || this.selectedPageType === 'colecoes' || this.selectedPageType === 'artigos') {
    //   console.log('chqamou highlightContainOption')
    //   setTimeout(() => {
    //     this.highlightContainOption();
    //   }, 150);

    // }

  }
  // Passo 1 (Customização) é considerado completo quando o widget já tem slicks
  // vinculados — condição usada tanto para liberar os passos 2/3 (Aparência e
  // Embbeding) quanto no card de status dos steps. Cada tipo de ingest guarda
  // a seleção em um lugar diferente (targetProducts só existe no modo Manual,
  // um picklist) — por isso o switch. Feeds usa published_count (dado real
  // vindo da API); Tags/Produtos usam proxy simples (só confirma que o
  // usuário configurou algo, não que existem slicks de verdade batendo com
  // a tag/produto — mesmo nível de garantia que hasDestinationDefined já usa
  // hoje pra Embedding, decisão consciente do usuário, SSAPP-23).
  get hasWidgetItems(): boolean {
    switch (this.selectedWidgetType) {
      case 'feeds':
        return (this.selectedFeeds || []).some(uid =>
          (this.feedsOptions.find(f => f.value === uid)?.published_count ?? 0) > 0
        );
      case 'tags':
        return (this.valuesSlicksTags?.length ?? 0) > 0;
      case 'produtos':
        return (this.selectedProdutosIngest?.length ?? 0) > 0;
      default:
        return (this.targetProducts?.length ?? 0) > 0;
    }
  }
  // p-steps usa ChangeDetectionStrategy.OnPush, então o [model] só percebe que
  // item.disabled/styleClass mudou quando o array recebe uma referência NOVA.
  // Por isso reatribuímos ctaOptions explicitamente (não num getter reavaliado
  // a cada ciclo de CD — isso travava a aba recriando o array/closures sem
  // parar) nos pontos conhecidos de mutação do picklist, e via ngDoCheck logo
  // abaixo para cobrir os vários pontos onde o destino (passo 3) muda.
  private refreshCtaOptions(): void {
    this.ctaOptions = this.widgetHelperService.getCtaOptions(this);
  }
  private lastHasWidgetItemsForSteps: boolean | null = null;
  private lastHasDestinationForSteps: boolean | null = null;
  ngDoCheck(): void {
    if (this.hasWidgetItems !== this.lastHasWidgetItemsForSteps || this.hasDestinationDefined !== this.lastHasDestinationForSteps) {
      this.lastHasWidgetItemsForSteps = this.hasWidgetItems;
      this.lastHasDestinationForSteps = this.hasDestinationDefined;
      this.refreshCtaOptions();
    }
  }
  // Passo 3 (Embbeding) completo = já existe um destino de exibição definido:
  // via integração (Nuvemshop/Shopify, aba "Página") ou via regra de URL manual
  // (aba HTML, Igual/Contém).
  get hasDestinationDefined(): boolean {
    if (this.hasIntegration) {
      return this.hasSelectedPageItem;
    }
    return (this.valuesContainTags?.length ?? 0) > 0 || (this.valuesEqualTags?.length ?? 0) > 0;
  }
  get canPublishWidget(): boolean {
    return this.hasWidgetItems && this.hasDestinationDefined;
  }
  onInputChange() { this.hasError1 = false; }
  createWidget() {
    let hasError = false;

    // Verifica se o título está preenchido
    if (!this.widgetTitle || this.widgetTitle.trim() === '') {
      this.hasErrorTitle = true;
      hasError = true;
    } else {
      this.hasErrorTitle = false;
    }

    // Verifica se o tipo de feed está preenchido
    if (!this.selectedWidgetType) {
      this.hasError1 = true;
      hasError = true;
    } else {
      this.hasError1 = false;
    }

    // Verifica se o tipo de Slick está preenchido
    if (!this.selectedSlickType) {
      this.hasError2 = true;
      hasError = true;
    } else {
      this.hasError2 = false;
    }

    // Se houver algum erro, interrompe o fluxo
    if (hasError) {
      return;
    }
    this.hasErrorTitle = false; // Reseta o erro se houver título válido
    if (this.issueForm) {
      const style: any = {};
      if (this.selectedTemplate === 'popup') {
        style['popup'] = {
          position: this.selectedPopupPosition || 'top-right', // Se nenhuma posição for selecionada, usa 'top-right' como padrão
          highlight: this.highlight,
          shape: this.selectedShape,
          background_color: this.bg_color,
          font_color: this.font_color,
        };
      } else { style[this.selectedTemplate] = { background_color: this.bg_color }; }
      const containRuleValues = this.valuesContainTags.join(','); const equalRuleValues = this.valuesEqualTags.join(',');
      this.issueForm = this.fb.group({
        title: [this.widgetTitle],
        feed_type: [this.selectedWidgetType],
        type: [0],
        smart: [0],
        template: [this.selectedTemplate],
        slick_filter: [this.selectedSlickType],
        published: [0],
        max_limit: [this.canLimitShowItens() && this.limitShowItens ? this.manualValue : null],
        tags: [this.getTagsToSave()],
        assets: [
          this.targetProducts.map((product, index) => ({
            id: product.id,
            position: index
          }))
        ],
        style: [Object.keys(style).length ? style : undefined],
        widget_rule: this.fb.group({
          device_display: this.fb.group({
            mobile: [this.showSmartphones],
            desktop: [this.showDesktops]
          }),
          url_display: this.fb.group({
            contain_rule: [containRuleValues],
            equal_rule: [equalRuleValues],
            url_rules: [this.ruleTree]
          })
        })
      });
      this.isLoadingSave = true; // Mostra o indicador de carregamento
      this.widgetService.createWidget(this.issueForm.value).pipe(takeUntil(this.destroy$)).subscribe({
        next: (response: WidgetDetailsResponse) => {
          this.isLoadingSave = false; // Esconde o indicador de carregamento
          this.messageService.add({ severity: 'success', summary: 'Widget Salvo', detail: 'O widget foi salvo com sucesso!' });
          this.widget_id = response.id;
          this.widget_uid = response.uid;
          this.currentWidgetUid = response.uid;
          this.location.replaceState(`/edit_widgets/${response.uid}`);
          this.isCreateMode = this.location.path().includes('/create_widget');
          this.isNewWidget = false;
          this.widgetPublished = false;
          this.isWidgetDetailsLoaded = true;
          this.refreshCtaOptions();
          this.cdr.detectChanges(); this.createWidgetBtn = false;
        },
        error: (error) => {
          this.isLoadingSave = false; // Esconde o indicador de carregamento
          let message = '';
          if (error.status === 400 || error.status === 403 || error.status === 401) {
            message = error.error.message;
          } else if (error.status === 500) {
            message = "Ops... Algo de errado aconteceu. Tente novamente mais tarde.";
          } else if (error.status !== 404) {
            message = error.error.message;
          }

          if (message) { this.showErrorDialog(message); }
        }
      });
    }
  }
  nuvemshopStyledTemplates = ['carousel', 'stories', 'inline', 'discover'];

  private applyNuvemshopWrapperStyleExtras(templateStyle: any): void {
    if (!templateStyle) return;
    this.titleAlignment = ['left', 'center', 'right'].includes(templateStyle.title_alignment) ? templateStyle.title_alignment : 'left';
    this.titleSpacing = typeof templateStyle.title_spacing === 'number' ? templateStyle.title_spacing : 24;

    this.paddingTop = templateStyle.padding_top || 0;
    this.paddingRight = templateStyle.padding_right || 0;
    this.paddingBottom = templateStyle.padding_bottom || 0;
    this.paddingLeft = templateStyle.padding_left || 0;
    this.paddingUnit = ['px', 'rem', '%'].includes(templateStyle.padding_unit) ? templateStyle.padding_unit : 'px';

    // Campos mobile: fallback pro valor desktop quando ausente (widgets
    // salvos antes desta feature não têm essas chaves).
    this.paddingTopMobile = templateStyle.padding_top_mobile ?? this.paddingTop;
    this.paddingRightMobile = templateStyle.padding_right_mobile ?? this.paddingRight;
    this.paddingBottomMobile = templateStyle.padding_bottom_mobile ?? this.paddingBottom;
    this.paddingLeftMobile = templateStyle.padding_left_mobile ?? this.paddingLeft;

    this.marginTop = templateStyle.margin_top || 0;
    this.marginRight = templateStyle.margin_right || 0;
    this.marginBottom = templateStyle.margin_bottom || 0;
    this.marginLeft = templateStyle.margin_left || 0;
    this.marginUnit = ['px', 'rem', '%'].includes(templateStyle.margin_unit) ? templateStyle.margin_unit : 'px';

    this.marginTopMobile = templateStyle.margin_top_mobile ?? this.marginTop;
    this.marginRightMobile = templateStyle.margin_right_mobile ?? this.marginRight;
    this.marginBottomMobile = templateStyle.margin_bottom_mobile ?? this.marginBottom;
    this.marginLeftMobile = templateStyle.margin_left_mobile ?? this.marginLeft;

    this.refreshSpacingLinkFlags();
  }

  // true quando o seletor Desktop/Mobile do topo da prévia (valSelect1Video)
  // está em Mobile — decide qual conjunto de campos (desktop ou mobile) o
  // painel de Espaçamento lê/escreve.
  get isEditingMobileSpacing(): boolean {
    return this.valSelect1Video?.value === 2;
  }

  // Recalcula os toggles de "vincular eixo" a partir dos valores do device
  // atualmente ativo — chamado no load e sempre que o usuário troca de device
  // (changeLandscape()), pra o ícone de âncora refletir o device certo.
  private refreshSpacingLinkFlags(): void {
    this.linkPaddingX = this.effectivePaddingLeft === this.effectivePaddingRight;
    this.linkPaddingY = this.effectivePaddingTop === this.effectivePaddingBottom;
    this.linkMarginX = this.effectiveMarginLeft === this.effectiveMarginRight;
    this.linkMarginY = this.effectiveMarginTop === this.effectiveMarginBottom;
  }

  // Getters/setters "ativos": redirecionam pro conjunto mobile ou desktop
  // conforme isEditingMobileSpacing. São o que o painel (inputs) e a prévia
  // (app-widget-template) efetivamente leem/escrevem.
  get effectivePaddingTop(): number { return this.isEditingMobileSpacing ? this.paddingTopMobile : this.paddingTop; }
  set effectivePaddingTop(v: number) { if (this.isEditingMobileSpacing) this.paddingTopMobile = v; else this.paddingTop = v; }
  get effectivePaddingRight(): number { return this.isEditingMobileSpacing ? this.paddingRightMobile : this.paddingRight; }
  set effectivePaddingRight(v: number) { if (this.isEditingMobileSpacing) this.paddingRightMobile = v; else this.paddingRight = v; }
  get effectivePaddingBottom(): number { return this.isEditingMobileSpacing ? this.paddingBottomMobile : this.paddingBottom; }
  set effectivePaddingBottom(v: number) { if (this.isEditingMobileSpacing) this.paddingBottomMobile = v; else this.paddingBottom = v; }
  get effectivePaddingLeft(): number { return this.isEditingMobileSpacing ? this.paddingLeftMobile : this.paddingLeft; }
  set effectivePaddingLeft(v: number) { if (this.isEditingMobileSpacing) this.paddingLeftMobile = v; else this.paddingLeft = v; }
  get effectiveMarginTop(): number { return this.isEditingMobileSpacing ? this.marginTopMobile : this.marginTop; }
  set effectiveMarginTop(v: number) { if (this.isEditingMobileSpacing) this.marginTopMobile = v; else this.marginTop = v; }
  get effectiveMarginRight(): number { return this.isEditingMobileSpacing ? this.marginRightMobile : this.marginRight; }
  set effectiveMarginRight(v: number) { if (this.isEditingMobileSpacing) this.marginRightMobile = v; else this.marginRight = v; }
  get effectiveMarginBottom(): number { return this.isEditingMobileSpacing ? this.marginBottomMobile : this.marginBottom; }
  set effectiveMarginBottom(v: number) { if (this.isEditingMobileSpacing) this.marginBottomMobile = v; else this.marginBottom = v; }
  get effectiveMarginLeft(): number { return this.isEditingMobileSpacing ? this.marginLeftMobile : this.marginLeft; }
  set effectiveMarginLeft(v: number) { if (this.isEditingMobileSpacing) this.marginLeftMobile = v; else this.marginLeft = v; }

  // Chamado pelo ngModelChange de cada input de padding/margin. Quando o eixo
  // está "ancorado" (linkPaddingX/Y), espelha o valor digitado no input irmão
  // (esquerda<->direita ou topo<->base) pra eles andarem juntos; senão cada
  // input fica independente. Sempre atua sobre o device ativo (effective*).
  onPaddingChange(axis: 'X' | 'Y', side: 'first' | 'second', value: number): void {
    const linked = axis === 'X' ? this.linkPaddingX : this.linkPaddingY;
    if (axis === 'X') {
      this.effectivePaddingLeft = side === 'first' ? value : (linked ? value : this.effectivePaddingLeft);
      this.effectivePaddingRight = side === 'second' ? value : (linked ? value : this.effectivePaddingRight);
    } else {
      this.effectivePaddingTop = side === 'first' ? value : (linked ? value : this.effectivePaddingTop);
      this.effectivePaddingBottom = side === 'second' ? value : (linked ? value : this.effectivePaddingBottom);
    }
    this.scheduleAutoSave();
  }

  onMarginChange(axis: 'X' | 'Y', side: 'first' | 'second', value: number): void {
    const linked = axis === 'X' ? this.linkMarginX : this.linkMarginY;
    if (axis === 'X') {
      this.effectiveMarginLeft = side === 'first' ? value : (linked ? value : this.effectiveMarginLeft);
      this.effectiveMarginRight = side === 'second' ? value : (linked ? value : this.effectiveMarginRight);
    } else {
      this.effectiveMarginTop = side === 'first' ? value : (linked ? value : this.effectiveMarginTop);
      this.effectiveMarginBottom = side === 'second' ? value : (linked ? value : this.effectiveMarginBottom);
    }
    this.scheduleAutoSave();
  }

  // Clique no botão de âncora: alterna o link e, ao ligar, sincroniza os dois
  // inputs do eixo (do device ativo) pro mesmo valor (usa o do primeiro campo
  // como referência).
  toggleLinkPadding(axis: 'X' | 'Y'): void {
    if (axis === 'X') {
      this.linkPaddingX = !this.linkPaddingX;
      if (this.linkPaddingX) this.effectivePaddingRight = this.effectivePaddingLeft;
    } else {
      this.linkPaddingY = !this.linkPaddingY;
      if (this.linkPaddingY) this.effectivePaddingBottom = this.effectivePaddingTop;
    }
    this.scheduleAutoSave();
  }

  toggleLinkMargin(axis: 'X' | 'Y'): void {
    if (axis === 'X') {
      this.linkMarginX = !this.linkMarginX;
      if (this.linkMarginX) this.effectiveMarginRight = this.effectiveMarginLeft;
    } else {
      this.linkMarginY = !this.linkMarginY;
      if (this.linkMarginY) this.effectiveMarginBottom = this.effectiveMarginTop;
    }
    this.scheduleAutoSave();
  }

  private getNuvemshopWrapperStyleExtras(): any {
    // Fase de testes: liberado para qualquer loja sem integração Shopify (Nuvemshop já suportado; HTML/sem integração liberado temporariamente).
    if (this.integrationPlatform === 'shopify' || !this.nuvemshopStyledTemplates.includes(this.selectedTemplate)) return {};
    return {
      show_title: this.showWidgetTitle,
      title_tag: this.widgetTitleTag,
      title_alignment: this.titleAlignment,
      title_spacing: this.titleSpacing,
      padding_top: this.paddingTop,
      padding_right: this.paddingRight,
      padding_bottom: this.paddingBottom,
      padding_left: this.paddingLeft,
      padding_top_mobile: this.paddingTopMobile,
      padding_right_mobile: this.paddingRightMobile,
      padding_bottom_mobile: this.paddingBottomMobile,
      padding_left_mobile: this.paddingLeftMobile,
      margin_top: this.marginTop,
      margin_right: this.marginRight,
      margin_bottom: this.marginBottom,
      margin_left: this.marginLeft,
      margin_top_mobile: this.marginTopMobile,
      margin_right_mobile: this.marginRightMobile,
      margin_bottom_mobile: this.marginBottomMobile,
      margin_left_mobile: this.marginLeftMobile,
      padding_unit: this.paddingUnit,
      margin_unit: this.marginUnit,
    };
  }
  hasErrorUrlDisplay: boolean = false;

  private shouldClearUrlDisplayRules(): boolean {
    return this.hasIntegration && this.selectedPageType !== 'outras';
  }

  async editWidget(n: number): Promise<void> {
    if (n === 0 && !this.isWidgetDetailsLoaded) return;
    let hasError = false;
    // Validações
    if (!this.widgetTitle || this.widgetTitle.trim() === '') {
      this.hasErrorTitle = true;
      hasError = true;
    } else {
      this.hasErrorTitle = false;
    }

    if (!this.selectedWidgetType) {
      this.hasError1 = true;
      hasError = true;
    } else {
      this.hasError1 = false;
    }

    if (!this.selectedSlickType) {
      this.hasError2 = true;
      hasError = true;
    } else {
      this.hasError2 = false;
    }

    if (hasError) {
      return; // Interrompe a execução caso tenha erro básico
    }

    console.log('chamou salvar')
    console.log(this.selectedTemplate)
    console.log(n)

    if (n == 0) {
      if (this.issueForm) {
        let style: any = {};
        if (this.selectedTemplate === 'popup') {
          style['popup'] = {
            position: this.selectedPopupPosition || 'top-right',
            highlight: this.highlight,
            shape: this.selectedShape,
            background_color: this.bg_color,
            font_color: this.font_color,
          };
        } else if (this.selectedTemplate === 'iframe') {
          style[this.selectedTemplate] = {
            selectedResolution: this.selectedResolution
          };
        } else if (this.selectedTemplate === 'inline') {
          style[this.selectedTemplate] = {
            selectedResolution: this.selectedResolution,
            showDescription: this.showDescription,
            showProducts: this.showProducts,
            ...this.getNuvemshopWrapperStyleExtras(),
          };
        } else if (this.selectedTemplate === 'carousel' || this.selectedTemplate === 'stories') {
          style[this.selectedTemplate] = {
            showDescription: this.showDescription,
            background_color: this.bg_color,
            font_color: this.font_color,
            position: this.selectedPopupPosition || 'top-right',
            showProducts: this.showProducts,
            ...this.getNuvemshopWrapperStyleExtras(),
          };
        } else if (this.selectedTemplate === 'discover') {
          style[this.selectedTemplate] = {
            design: this.discoverLayout || 'grid',
            icon: this.discoverIcon || 'cart',
            showFilterBar: this.discoverShowFilterBar ?? true,
            showBadgeBar: this.discoverShowPostItemBadge ?? true,
            ...this.getNuvemshopWrapperStyleExtras(),
          };
        } else {
          style[this.selectedTemplate] = {
            background_color: this.bg_color
          };
        }

        const shouldClearUrlDisplayRules = this.shouldClearUrlDisplayRules();
        const containRuleValues = shouldClearUrlDisplayRules ? [] : this.valuesContainTags;
        const equalRuleValues = shouldClearUrlDisplayRules ? [] : this.valuesEqualTags;


        const feeds = this.selectedWidgetType === 'feeds' ? this.selectedFeeds || [] : [];
        console.log('chamouuuuu')
        this.issueForm = this.fb.group({
          title: [this.widgetTitle],
          show_title: [this.showWidgetTitle ? 1 : 0],
          title_tag: [this.widgetTitleTag],
          published: [this.widgetPublished ? 1 : 0],
          feed_type: [this.selectedWidgetType],
          feeds: [feeds],
          type: [0],
          smart: [0],
          template: [this.selectedTemplate],
          page_type: [this.selectedPageType],
          url_display: [],
          slick_filter: [this.selectedSlickType],
          max_limit: [this.canLimitShowItens() && this.limitShowItens ? this.manualValue : null],
          tags: [this.getTagsToSave()],
          assets: [
            this.targetProducts.map((product, index) => ({
              id: product.id,
              position: index
            }))
          ],
          style: [Object.keys(style).length ? style : undefined],
          widget_rule: this.fb.group({
            device_display: this.fb.group({
              mobile: [this.showSmartphones],
              desktop: [this.showDesktops]
            }),
            url_display: this.fb.group({
              contain_rule: [containRuleValues],
              equal_rule: [equalRuleValues],
              url_rules: [this.ruleTree]
            })
          })
        });


        if (this.widget_id) {
          this.isLoadingSave = true;
          this.widgetService.editWidget(this.issueForm.value, this.widget_id).pipe(takeUntil(this.destroy$)).subscribe({
            next: (response) => {
              this.isLoadingSave = false;
              this.toggleRefreshTrigger();
            },
            error: (error) => {
              this.isLoadingSave = false;
              let message = '';
              if ([400, 403, 401, 404].includes(error.status)) {
                message = error.error.message;
              } else if (error.status === 500) {
                message = "Ops... Algo de errado aconteceu. Tente novamente mais tarde.";
              } else {
                message = error.error.message;
              }
              if (message) {
                this.showErrorDialog(message);
              }
              // reject(error); // Rejeita a Promise caso haja erro
            }
          });
        }

      } else {
        this.isLoadingSave = false;
        //resolve(); // Resolve a Promise caso não haja edição para fazer
      }
    } else {
      ///////////////////////
      // 🔥 Faz a requisição antes de salvar
      const urlDisplayToSave = this.getUrlDisplay();
      this.widgetService.filterWidgetsByPageType(this.selectedPageType, this.selectedTemplate, this.currentWidgetUid)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (widgets) => {
            // 🔍 Verifica se a URL já existe nos widgets retornados
            const alreadyExists = widgets.some(widget => widget.url_display === urlDisplayToSave);

            if (alreadyExists) {
              // 🚨 URL já cadastrada, exibe erro e interrompe o salvamento
              this.hasErrorUrlDisplay = true;
              this.activeOption = 2;
              return;
            }

            // 🟢 Continua com a edição do widget
            this.executeEditWidget(n, urlDisplayToSave);
          },
          error: (error) => {
            console.error('Erro ao buscar widgets:', error);
          }
        });
      ///////////////////////
    }
  }
  private executeEditWidget(n: number, urlDisplayToSave: string): void {
    if (this.issueForm) {
      let style: any = {};
      if (this.selectedTemplate === 'popup') {
        style['popup'] = {
          position: this.selectedPopupPosition || 'top-right',
          highlight: this.highlight,
          shape: this.selectedShape,
          background_color: this.bg_color,
          font_color: this.font_color,
        };
      } else if (this.selectedTemplate === 'iframe') {
        style[this.selectedTemplate] = {
          selectedResolution: this.selectedResolution
        };
      } else if (this.selectedTemplate === 'inline') {
        style[this.selectedTemplate] = {
          selectedResolution: this.selectedResolution,
          showDescription: this.showDescription,
          showProducts: this.showProducts,
          ...this.getNuvemshopWrapperStyleExtras(),
        };
      } else if (this.selectedTemplate === 'carousel' || this.selectedTemplate === 'stories') {
        style[this.selectedTemplate] = {
          showDescription: this.showDescription,
          background_color: this.bg_color,
          font_color: this.font_color,
          position: this.selectedPopupPosition || 'top-right',
          showProducts: this.showProducts,
          ...this.getNuvemshopWrapperStyleExtras(),
        };
      } else if (this.selectedTemplate === 'discover') {
        style[this.selectedTemplate] = {
          design: this.discoverLayout || 'grid',
          icon: this.discoverIcon || 'cart',
          showFilterBar: this.discoverShowFilterBar ?? true,
          showBadgeBar: this.discoverShowPostItemBadge ?? true,
          ...this.getNuvemshopWrapperStyleExtras(),
        };
      } else {
        style[this.selectedTemplate] = {
          background_color: this.bg_color
        };
      }

      const shouldClearUrlDisplayRules = this.shouldClearUrlDisplayRules();
      const containRuleValues = shouldClearUrlDisplayRules ? [] : this.valuesContainTags;
      const equalRuleValues = shouldClearUrlDisplayRules ? [] : this.valuesEqualTags;
      const feeds = this.selectedWidgetType === 'feeds' ? this.selectedFeeds || [] : [];
      console.log('chamouuuuu2')
      this.issueForm = this.fb.group({
        title: [this.widgetTitle],
        published: [this.widgetPublished ? 1 : 0],
        feed_type: [this.selectedWidgetType],
        feeds: [feeds],
        type: [0],
        smart: [0],
        template: [this.selectedTemplate],
        page_type: [this.selectedPageType],
        url_display: [urlDisplayToSave],
        slick_filter: [this.selectedSlickType],
        max_limit: [this.canLimitShowItens() && this.limitShowItens ? this.manualValue : null],
        tags: [this.getTagsToSave()],
        assets: [
          this.targetProducts.map((product, index) => ({
            id: product.id,
            position: index
          }))
        ],
        style: [Object.keys(style).length ? style : undefined],
        widget_rule: this.fb.group({
          device_display: this.fb.group({
            mobile: [this.showSmartphones],
            desktop: [this.showDesktops]
          }),
          url_display: this.fb.group({
            contain_rule: [containRuleValues],
            equal_rule: [equalRuleValues],
            url_rules: [this.ruleTree]
          })
        })
      });


      if (this.widget_id) {
        this.isLoadingSave = true;
        this.widgetService.editWidget(this.issueForm.value, this.widget_id).pipe(takeUntil(this.destroy$)).subscribe({
          next: (response) => {
            if (n == 1) {
              this.messageService.add({
                severity: 'success',
                summary: 'Widget Editado',
                detail: 'O widget foi editado com sucesso!'
              });
            }
            this.isLoadingSave = false;
            this.toggleRefreshTrigger();
          },
          error: (error) => {
            this.isLoadingSave = false;
            let message = '';
            if ([400, 403, 401, 404].includes(error.status)) {
              message = error.error.message;
            } else if (error.status === 500) {
              message = "Ops... Algo de errado aconteceu. Tente novamente mais tarde.";
            } else {
              message = error.error.message;
            }
            if (message) {
              this.showErrorDialog(message);
            }
            // reject(error); // Rejeita a Promise caso haja erro
          }
        });
      }

    } else {
      this.isLoadingSave = false;
      //resolve(); // Resolve a Promise caso não haja edição para fazer
    }
  }
  getUrlDisplay(): string {
    switch (this.selectedPageType) {
      case 'produtos':
        return this.selectedProduct?.displayUrl || '';
      case 'colecoes':
        return this.selectedCollection?.displayUrl || '';
      case 'artigos':
        return this.selectedArticle?.displayUrl || '';
      case 'homepage':
        if (!this.ss_homepage_url) return '';
        return this.ss_homepage_url.startsWith('http') ? this.ss_homepage_url : `https://${this.ss_homepage_url}`;
      default:
        return '';
    }
  }

  private toggleRefreshTrigger() {
    this.refreshTrigger = !this.refreshTrigger; // Altera o valor de true para false, ou vice-versa
    this.cdr.detectChanges();
  }
  showErrorDialog(message: string) {
    this.messageService.add({ severity: 'error', summary: 'Erro', detail: message, icon: 'pi pi-times' });
  }
  checkInputTitle() { this.hasErrorTitle = !this.widgetTitle || this.widgetTitle.trim().length === 0; }
  clearSlickMaps() { this.valuesSlicksTags = []; this.showClearSlicksTags = false; }
  async showSlickClearFunction() {
    if (this.valuesSlicksTags && this.valuesSlicksTags?.length > 0) {
      this.showClearSlicksTags = true;
    } else {
      this.showClearSlicksTags = false;
    }
    await this.editWidget(0);
  }
  async onMoveToSource(event: any) {
    this.isCreateMode = this.location.path().includes('/create_widget');
    if (!this.isCreateMode) {

      // Pegando o primeiro item, já que sempre estamos movendo um por vez
      const movedItem = event.items[0];
      if (movedItem && movedItem.uid) {
        const widget_uid = movedItem.uid;

        // Atualizando o valor do formulário com o UID do item movido
        this.issueForm = this.fb.group({
          uid: widget_uid,
        });

        // Fazer a requisição para remover o vínculo do widget com o asset movido
        this.widgetService.subWidget(this.issueForm.value, this.widget_uid).pipe(takeUntil(this.destroy$)).subscribe({
          next: (response) => {
            this.isLoadingSave = false;
            this.editWidget(0);
          },
          error: (error) => {
            this.isLoadingSave = false;
            let message = '';
            if (error.status === 400 || error.status === 403 || error.status === 401) {
              message = error.error.message;
            } else if (error.status === 500) {
              message = "Ops... Algo de errado aconteceu. Tente novamente mais tarde.";
            } else {
              message = error.error.message;
            }
            if (message) {
              this.showErrorDialog(message);
            }
          }
        });
      }
    }
    this.targetProducts = [...this.targetProducts];
    this.targetProductsSubject.next(this.targetProducts);
    this.refreshCtaOptions();

  }
  async onMoveToTarget(event: any) {
    this.isCreateMode = this.location.path().includes('/create_widget');
    if (!this.isCreateMode) {
      // Atualizar as posições dos itens no `targetProducts`
      //this.targetProducts = [...this.targetProducts];
      // Atualizando o valor do formulário com a lista de itens e suas posições
      this.issueForm = this.fb.group({
        items: [this.targetProducts]
      });
      // Enviar a lista completa para o backend
      this.widgetService.addWidget(this.issueForm.value, this.widget_uid).pipe(takeUntil(this.destroy$)).subscribe({
        next: (response) => {
          this.isLoadingSave = false;
          this.editWidget(0);
        },
        error: (error) => {
          this.isLoadingSave = false;
          let message = '';
          if (error.status === 400 || error.status === 403 || error.status === 401) {
            message = error.error.message;
          } else if (error.status === 500) {
            message = "Ops... Algo de errado aconteceu. Tente novamente mais tarde.";
          } else {
            message = error.error.message;
          }
          if (message) {
            this.showErrorDialog(message);
          }
        }
      });
    }
    this.targetProducts = [...this.targetProducts]; // Atualiza a referência
    this.targetProductsSubject.next(this.targetProducts);
    this.refreshCtaOptions();
  }

  updateProductPositions(): void { this.targetProducts.forEach((product, index) => { product.position = index; }); }
  closeCopyTemplate(n: number) { if (n == 0) { this.displaySidebar = false; } else { this.displayCommandMenu = false; } }
  onSwitchChange(event: any): void { this.limitShowItens = event.checked; this.cdr.detectChanges(); }
  // Tipos de ingest que suportam "Limitar quantidade exibida" (era só 'tags').
  private readonly limitShowItensTypes = ['tags', 'feeds', 'produtos'];
  canLimitShowItens(): boolean { return this.limitShowItensTypes.includes(this.selectedWidgetType); }
  onSwitchChangeDescription(event: any): void { this.showDescription = event.checked; this.cdr.detectChanges(); }
  onSwitchChangeProducts(event: any): void { this.showProducts = event.checked; this.cdr.detectChanges(); }
  onSwitchChangeMobile(event: any): void { this.showSmartphones = event.checked; this.cdr.detectChanges(); }
  onSwitchChangeDesktop(event: any): void { this.showDesktops = event.checked; this.cdr.detectChanges(); }
  filterWidgetTypes(event: any) { this.filteredResults = this.widgetHelperService.filterItems(this.widgetTypes, event.query); }
  filterSlickTypes(event: any) {
    this.filteredResultsSlicks = this.widgetHelperService.filterItems(this.slickTypes, event.query);
  }
  selectTemplate(template: string) {
    this.selectedTemplate = template;
  }
  ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
    this.previewContainerObserver?.disconnect();
    this.layoutPaddingBottomEls.forEach(el => this.renderer.removeStyle(el, 'padding-bottom'));
    this.layoutPaddingBottomEls = [];
    this.detachAssetsPickListScrollListener();
    this.destroy$.next();
    this.destroy$.complete();
    if (this.containerHeightLockRaf != null) {
      cancelAnimationFrame(this.containerHeightLockRaf);
      this.containerHeightLockRaf = null;
    }
  }
  onTouchStart(event: Event) {
    this.isDragDrop = true;
    this.cdr.detectChanges();
  }

  onTouchMove(event: Event) {
    this.isDragDrop = true;
    if (this.isDragDrop) {
      event.preventDefault(); // Previne o comportamento padrão de scroll
    }
    this.cdr.detectChanges();
  }

  onTouchEnd(event: Event) {
    this.isDragDrop = false;
    this.cdr.detectChanges();
  }

  ///////////////////////////////
  // Mostrar modal
  // Todos os produtos carregados
  filteredProducts: any[] = []; // Produtos filtrados com base na busca
  // Produtos filtrados com base na busca
  //valuesEqualTags: string[] = []; // Valores do p-chips
  searchQuery: string = ''; // Termo de busca
  filterProducts(): void {
    const query = this.searchQuery.toLowerCase();
    this.productsList = this.recentProducts.filter(product =>
      product.title.toLowerCase().includes(query)
    );
  }
  // Filtro para coleções
  filterCollections(): void {
    const query = this.searchQuery.toLowerCase();
    this.collectionsList = this.recentCollections.filter(collection =>
      collection.title.toLowerCase().includes(query)
    );
  }

  // Filtro para artigos
  filterArticles(): void {
    const query = this.searchQuery.toLowerCase();
    this.articlesList = this.recentArticles.filter(article =>
      article.title.toLowerCase().includes(query)
    );
  }
  addProductToChips(product: any): void {
    if (!this.valuesEqualTags.includes(product.product_url)) {
      this.valuesEqualTags = [...this.valuesEqualTags, product.product_url]; // Cria uma nova referência do array
      this.cdr.detectChanges(); // Notifica o Angular para re-renderizar o componente
      this.showClearEqualTags = true;
    }
  }

  showCommandMenuModal(): void {
    this.displayAguarde = true;
    this.productService.listProducts().subscribe({
      next: (response) => {
        this.recentProducts = response.products.map((product: any) => ({
          thumbnail: product.thumbnail,
          title: product.title,
          product_url: product.product_url
        }));
        this.filteredProducts = [...this.recentProducts]; // Inicializa com todos os produtos
        this.displayCommandMenu = true;
        this.displayAguarde = false;
      },
      error: (error) => {
        console.error('Erro ao carregar produtos:', error);
      }
    });

  }


  valuesEqualTagsString: string = '';
  displayCommandMenu = false;
  recentItems = ['unread mails', 'go to last mail', 'lock account', 'profile'];
  allOptions = [
    { label: 'System Settings', description: 'Change your system preferences', icon: 'pi pi-cog', shortcut: 'S' },
    { label: 'My Profile', description: 'Go to your profile', icon: 'pi pi-user', shortcut: 'P' },
    { label: 'Switch to Dark Mode', description: 'Switch to dark mode save your eyes', icon: 'pi pi-moon', shortcut: 'D' },
    { label: 'Log out', description: 'End your session', icon: 'pi pi-sign-out', shortcut: 'L' },
  ];
  filteredOptions = [...this.allOptions];
  // Filtrar opções com base na busca
  filterOptions() {
    const query = this.searchQuery.toLowerCase();
    this.filteredOptions = this.allOptions.filter((option) =>
      option.label.toLowerCase().includes(query) || option.description.toLowerCase().includes(query)
    );
  }

  // Selecionar uma opção
  selectOption(option: any) {
    this.displayCommandMenu = false; // Fecha o modal
  }

  // Selecionar um item recente
  selectRecent(recent: string) {
    //console.log('Item recente selecionado:', recent);
  }
  onOpenSidebar(): void {
    this.displaySidebar = true;
  }
  private observer?: MutationObserver;
  initializeObserver() {
    // Desconectar o observador anterior, se existir
    if (this.observer) {
      this.observer.disconnect();
    }

    console.log('chamou multi');
    this.observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
          const target = mutation.target as HTMLElement;
          if (target.classList.contains('p-picklist-item') && target.style.zIndex !== '1500' ||
            target.classList.contains('p-orderlist-item') && target.style.zIndex !== '1500') {
            target.style.zIndex = '421500'; // Definindo um novo z-index
          }
        }
      });
    });

    this.observer.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['style'] });
  }

  openShopifyThemeEditor(): void {
    if (this.integrationPlatform === 'shopify') {
      const shopifyTargetUrl = this.buildShopifyThemeEditorUrl();
      console.log('[Shopify Theme Editor] URL gerada:', shopifyTargetUrl);
      if (!shopifyTargetUrl) {
        return;
      }
      window.open(shopifyTargetUrl, '_blank', 'noopener');
      return;
    }

    if (!this.storeEditToken) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Aguarde',
        detail: 'Token de acesso ainda sendo carregado, tente novamente em instantes.'
      });
      this.fetchStoreEditToken();
      return;
    }
    if (this.storeEditTokenExpiresAt && new Date(this.storeEditTokenExpiresAt) < new Date()) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Token expirado',
        detail: 'Gerando novo token, tente novamente em instantes.'
      });
      this.storeEditToken = undefined;
      this.fetchStoreEditToken();
      return;
    }
    const targetUrl = this.buildSelectedItemEditUrl();
    if (!targetUrl) {
      return;
    }
    window.open(targetUrl, '_blank', 'noopener');
  }

}
